
export const Github = (props) => {
    return (
        <svg
          aria-hidden="true"
          data-prefix="fab"
          data-icon="github"
          className="prefix__svg-inline--fa prefix__fa-github prefix__fa-w-16"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 496 512"
          {...props}
        >
          <path
            fill={props.fill}
            d="M165.9 397.4c0 2-2.3 3.6-5.2 3.6-3.3.3-5.6-1.3-5.6-3.6 0-2 2.3-3.6 5.2-3.6 3-.3 5.6 1.3 5.6 3.6zm-31.1-4.5c-.7 2 1.3 4.3 4.3 4.9 2.6 1 5.6 0 6.2-2s-1.3-4.3-4.3-5.2c-2.6-.7-5.5.3-6.2 2.3zm44.2-1.7c-2.9.7-4.9 2.6-4.6 4.9.3 2 2.9 3.3 5.9 2.6 2.9-.7 4.9-2.6 4.6-4.6-.3-1.9-3-3.2-5.9-2.9zM244.8 8C106.1 8 0 113.3 0 252c0 110.9 69.8 205.8 169.5 239.2 12.8 2.3 17.3-5.6 17.3-12.1 0-6.2-.3-40.4-.3-61.4 0 0-70 15-84.7-29.8 0 0-11.4-29.1-27.8-36.6 0 0-22.9-15.7 1.6-15.4 0 0 24.9 2 38.6 25.8 21.9 38.6 58.6 27.5 72.9 20.9 2.3-16 8.8-27.1 16-33.7-55.9-6.2-112.3-14.3-112.3-110.5 0-27.5 7.6-41.3 23.6-58.9-2.6-6.5-11.1-33.3 2.6-67.9 20.9-6.5 69 27 69 27 20-5.6 41.5-8.5 62.8-8.5s42.8 2.9 62.8 8.5c0 0 48.1-33.6 69-27 13.7 34.7 5.2 61.4 2.6 67.9 16 17.7 25.8 31.5 25.8 58.9 0 96.5-58.9 104.2-114.8 110.5 9.2 7.9 17 22.9 17 46.4 0 33.7-.3 75.4-.3 83.6 0 6.5 4.6 14.4 17.3 12.1C428.2 457.8 496 362.9 496 252 496 113.3 383.5 8 244.8 8zM97.2 352.9c-1.3 1-1 3.3.7 5.2 1.6 1.6 3.9 2.3 5.2 1 1.3-1 1-3.3-.7-5.2-1.6-1.6-3.9-2.3-5.2-1zm-10.8-8.1c-.7 1.3.3 2.9 2.3 3.9 1.6 1 3.6.7 4.3-.7.7-1.3-.3-2.9-2.3-3.9-2-.6-3.6-.3-4.3.7zm32.4 35.6c-1.6 1.3-1 4.3 1.3 6.2 2.3 2.3 5.2 2.6 6.5 1 1.3-1.3.7-4.3-1.3-6.2-2.2-2.3-5.2-2.6-6.5-1zm-11.4-14.7c-1.6 1-1.6 3.6 0 5.9 1.6 2.3 4.3 3.3 5.6 2.3 1.6-1.3 1.6-3.9 0-6.2-1.4-2.3-4-3.3-5.6-2z"
          />
        </svg>
      )
}

export const LinkedIn = (props) => {
  return (
    <svg 
      aria-hidden="true"
      data-prefix="fab"
      data-icon="linkedin"
      className="prefix__svg-inline--fa prefix__fa-linkedin prefix__fa-w-16"
      xmlns="http://www.w3.org/2000/svg" 
      viewBox="0 0 448 512" 
      {...props}
    >
      <path d="M416 32H31.9C14.3 32 0 46.5 0 64.3v383.4C0 465.5 14.3 480 31.9 480H416c17.6 0 32-14.5 32-32.3V64.3c0-17.8-14.4-32.3-32-32.3zM135.4 416H69V202.2h66.5V416zm-33.2-243c-21.3 0-38.5-17.3-38.5-38.5S80.9 96 102.2 96c21.2 0 38.5 17.3 38.5 38.5 0 21.3-17.2 38.5-38.5 38.5zm282.1 243h-66.4V312c0-24.8-.5-56.7-34.5-56.7-34.6 0-39.9 27-39.9 54.9V416h-66.4V202.2h63.7v29.2h.9c8.9-16.8 30.6-34.5 62.9-34.5 67.2 0 79.7 44.3 79.7 101.9V416z" />
    </svg>
  )
}

export const Phone = (props) => {
  return (
    <svg 
      aria-hidden="true"
      data-prefix="fas"
      data-icon="phone"
      className="prefix__svg-inline--fa prefix__fa-phone prefix__fa-w-16"
      xmlns="http://www.w3.org/2000/svg" 
      viewBox="0 0 512 512" 
      {...props}
    >
      <path d="M164.9 24.6c-7.7-18.6-28-28.5-47.4-23.2l-88 24C12.1 30.2 0 46 0 64c0 247.4 200.6 448 448 448 18 0 33.8-12.1 38.6-29.5l24-88c5.3-19.4-4.6-39.7-23.2-47.4l-96-40c-16.3-6.8-35.2-2.1-46.3 11.6L304.7 368c-70.4-33.3-127.4-90.3-160.7-160.7l49.3-40.3c13.7-11.2 18.4-30 11.6-46.3l-40-96z" />
    </svg>
  )
}

export const Email = (props) => {
  return (
    <svg 
      aria-hidden="true"
      data-prefix="fas"
      data-icon="envelope"
      className="prefix__svg-inline--fa prefix__fa-envelope prefix__fa-w-16"
      xmlns="http://www.w3.org/2000/svg" 
      viewBox="0 0 512 512" 
      {...props}
    >
      <path d="M48 64C21.5 64 0 85.5 0 112c0 15.1 7.1 29.3 19.2 38.4l217.6 163.2c11.4 8.5 27 8.5 38.4 0l217.6-163.2c12.1-9.1 19.2-23.3 19.2-38.4 0-26.5-21.5-48-48-48H48zM0 176v208c0 35.3 28.7 64 64 64h384c35.3 0 64-28.7 64-64V176L294.4 339.2a63.9 63.9 0 0 1-76.8 0L0 176z" />
    </svg>
  )
}

export const YinYang = (props) => {
    return (
        <svg
          aria-hidden="true"
          data-prefix="fas"
          data-icon="yin-yang"
          className="prefix__svg-inline--fa prefix__fa-yin-yang prefix__fa-w-16"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 496 512"
          {...props}
        >
          <path
            fill={props.fill}
            d="M248 8C111.03 8 0 119.03 0 256s111.03 248 248 248 248-111.03 248-248S384.97 8 248 8zm0 376c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm0-128c-53.02 0-96 42.98-96 96s42.98 96 96 96c-106.04 0-192-85.96-192-192S141.96 64 248 64c53.02 0 96 42.98 96 96s-42.98 96-96 96zm0-128c-17.67 0-32 14.33-32 32s14.33 32 32 32 32-14.33 32-32-14.33-32-32-32z"
          />
        </svg>
      )
}

export const Link = (props) => {
  return (
    <svg
      aria-hidden="true"
      data-prefix="fas"
      data-icon="link"
      className="prefix__svg-inline--fa prefix__fa-link prefix__fa-w-16"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 512 512"
      {...props}
      
    >
      <path
        fill={props.fill}
        
        d="M326.612 185.391c59.747 59.809 58.927 155.698.36 214.59-.11.12-.24.25-.36.37l-67.2 67.2c-59.27 59.27-155.699 59.262-214.96 0-59.27-59.26-59.27-155.7 0-214.96l37.106-37.106c9.84-9.84 26.786-3.3 27.294 10.606.648 17.722 3.826 35.527 9.69 52.721 1.986 5.822.567 12.262-3.783 16.612l-13.087 13.087c-28.026 28.026-28.905 73.66-1.155 101.96 28.024 28.579 74.086 28.749 102.325.51l67.2-67.19c28.191-28.191 28.073-73.757 0-101.83-3.701-3.694-7.429-6.564-10.341-8.569a16.037 16.037 0 01-6.947-12.606c-.396-10.567 3.348-21.456 11.698-29.806l21.054-21.055c5.521-5.521 14.182-6.199 20.584-1.731a152.482 152.482 0 0120.522 17.197zM467.547 44.449c-59.261-59.262-155.69-59.27-214.96 0l-67.2 67.2c-.12.12-.25.25-.36.37-58.566 58.892-59.387 154.781.36 214.59a152.454 152.454 0 0020.521 17.196c6.402 4.468 15.064 3.789 20.584-1.731l21.054-21.055c8.35-8.35 12.094-19.239 11.698-29.806a16.037 16.037 0 00-6.947-12.606c-2.912-2.005-6.64-4.875-10.341-8.569-28.073-28.073-28.191-73.639 0-101.83l67.2-67.19c28.239-28.239 74.3-28.069 102.325.51 27.75 28.3 26.872 73.934-1.155 101.96l-13.087 13.087c-4.35 4.35-5.769 10.79-3.783 16.612 5.864 17.194 9.042 34.999 9.69 52.721.509 13.906 17.454 20.446 27.294 10.606l37.106-37.106c59.271-59.259 59.271-155.699.001-214.959z"
      />
    </svg>
  )
}

export const Flower = (props) => { 
  return (
    <svg
      aria-hidden="true"
      data-prefix="fas"
      data-icon="flower"
      className="prefix__svg-inline--fa prefix__fa-flower prefix__fa-w-20"
      xmlns="http://www.w3.org/2000/svg"
      shapeRendering="crispEdges"
      viewBox="0 -0.5 64 64"
      {...props}
    >
      <path
        stroke="#cc9abc"
        d="M23 15h7m-9 1h11m-11 1h4m3 0h6m-13 1h2m7 0h5m-14 1h2m9 0h4m-15 1h2m10 0h3m-21 1h4m2 0h2m11 0h3m-24 1h10m11 0h8m-30 1h4m1 0h7m10 0h11m-33 1h3m4 0h6m8 0h6m1 0h6m-34 1h2m7 0h4m8 0h3m7 0h4m-35 1h2m8 0h3m19 0h3m-35 1h2m31 0h3m-36 1h3m30 0h3m-36 1h3m19 0h13m-35 1h4m18 0h12m-33 1h4m2 0h4m11 0h7m-27 1h9m15 0h4m-27 1h7m17 0h4m-24 1h2m8 0h3m8 0h3m-24 1h2m8 0h4m8 0h2m-24 1h2m7 0h6m7 0h2m-24 1h3m6 0h8m3 0h4m-24 1h4m4 0h3m2 0h11m-23 1h10m4 0h7m-20 1h8"
      />
      <path
        stroke="#696a6a"
        d="M26 25h6m-7 1h9m-13 1h7m2 0h5m-15 1h7m5 0h5m-17 1h3m10 0h4m-17 1h2m13 0h2m-17 1h2m-2 1h3m11 0h1m-11 1h1m8 0h2m-11 1h12m-13 1h12"
      />
    </svg>
  )
}

export const Sun1 = (props) => { 
  return (
    <svg
      aria-hidden="true"
      data-prefix="fas"
      data-icon="sun"
      className="prefix__svg-inline--fa prefix__fa-sun prefix__fa-w-20"
      xmlns="http://www.w3.org/2000/svg"
      shapeRendering="crispEdges"
      viewBox="0 0 48 48"
      {...props}
    >
      <g transform="translate(4, 8)">
        <path
        fill="#838383"
        d="M16 4h1v1h-1zM17 4h1v1h-1zM18 4h1v1h-1zM19 4h1v1h-1zM20 4h1v1h-1zM21 4h1v1h-1zM22 4h1v1h-1z"
      />
      <path
        fill="#E6D9BD"
        d="M14 5h1v1h-1zM15 5h1v1h-1zM16 5h1v1h-1zM17 5h1v1h-1zM18 5h1v1h-1zM19 5h1v1h-1zM20 5h1v1h-1zM21 5h1v1h-1zM22 5h1v1h-1zM23 5h1v1h-1zM24 5h1v1h-1z"
      />
      <path fill="#A0A0A0" d="M10 6h1v1h-1z" />
      <path fill="#838383" d="M13 6h1v1h-1z" />
      <path fill="#E6D9BD" d="M14 6h1v1h-1z" />
      <path fill="#A0A0A0" d="M15 6h1v1h-1zM16 6h1v1h-1zM17 6h1v1h-1z" />
      <path fill="#E6D9BD" d="M18 6h1v1h-1z" />
      <path
        fill="#838383"
        d="M19 6h1v1h-1zM20 6h1v1h-1zM21 6h1v1h-1zM22 6h1v1h-1zM23 6h1v1h-1zM24 6h1v1h-1zM25 6h1v1h-1z"
      />
      <path fill="#A0A0A0" d="M28 6h1v1h-1z" />
      <path fill="#E6D9BD" d="M12 7h1v1h-1zM13 7h1v1h-1zM14 7h1v1h-1z" />
      <path fill="#A0A0A0" d="M15 7h1v1h-1z" />
      <path fill="#E6D9BD" d="M16 7h1v1h-1z" />
      <path fill="#A0A0A0" d="M17 7h1v1h-1z" />
      <path
        fill="#E6D9BD"
        d="M18 7h1v1h-1zM19 7h1v1h-1zM20 7h1v1h-1zM21 7h1v1h-1zM22 7h1v1h-1zM23 7h1v1h-1zM24 7h1v1h-1zM25 7h1v1h-1zM26 7h1v1h-1z"
      />
      <path fill="#A0A0A0" d="M8 8h1v1H8zM9 8h1v1H9z" />
      <path fill="#838383" d="M11 8h1v1h-1zM12 8h1v1h-1zM13 8h1v1h-1z" />
      <path fill="#E6D9BD" d="M14 8h1v1h-1z" />
      <path fill="#A0A0A0" d="M15 8h1v1h-1zM16 8h1v1h-1zM17 8h1v1h-1z" />
      <path fill="#E6D9BD" d="M18 8h1v1h-1z" />
      <path
        fill="#838383"
        d="M19 8h1v1h-1zM20 8h1v1h-1zM21 8h1v1h-1zM22 8h1v1h-1zM23 8h1v1h-1zM24 8h1v1h-1zM25 8h1v1h-1zM26 8h1v1h-1zM27 8h1v1h-1z"
      />
      <path fill="#A0A0A0" d="M29 8h1v1h-1zM30 8h1v1h-1z" />
      <path
        fill="#E6D9BD"
        d="M11 9h1v1h-1zM12 9h1v1h-1zM13 9h1v1h-1zM14 9h1v1h-1zM15 9h1v1h-1zM16 9h1v1h-1zM17 9h1v1h-1zM18 9h1v1h-1zM19 9h1v1h-1zM20 9h1v1h-1zM21 9h1v1h-1zM22 9h1v1h-1zM23 9h1v1h-1zM24 9h1v1h-1zM25 9h1v1h-1zM26 9h1v1h-1zM27 9h1v1h-1z"
      />
      <path fill="#A0A0A0" d="M6 10h1v1H6zM8 10h1v1H8z" />
      <path
        fill="#838383"
        d="M10 10h1v1h-1zM11 10h1v1h-1zM12 10h1v1h-1zM13 10h1v1h-1zM14 10h1v1h-1zM15 10h1v1h-1zM16 10h1v1h-1zM17 10h1v1h-1zM18 10h1v1h-1zM19 10h1v1h-1zM20 10h1v1h-1zM21 10h1v1h-1zM22 10h1v1h-1zM23 10h1v1h-1zM24 10h1v1h-1zM25 10h1v1h-1zM26 10h1v1h-1zM27 10h1v1h-1zM28 10h1v1h-1z"
      />
      <path fill="#A0A0A0" d="M30 10h1v1h-1zM32 10h1v1h-1z" />
      <path
        fill="#E6D9BD"
        d="M10 11h1v1h-1zM11 11h1v1h-1zM12 11h1v1h-1zM13 11h1v1h-1zM14 11h1v1h-1zM15 11h1v1h-1zM16 11h1v1h-1zM17 11h1v1h-1zM18 11h1v1h-1zM19 11h1v1h-1zM20 11h1v1h-1zM21 11h1v1h-1zM22 11h1v1h-1zM23 11h1v1h-1zM24 11h1v1h-1zM25 11h1v1h-1zM26 11h1v1h-1zM27 11h1v1h-1zM28 11h1v1h-1z"
      />
      <path
        fill="#A0A0A0"
        d="M2 12h1v1H2zM4 12h1v1H4zM5 12h1v1H5zM7 12h1v1H7zM8 12h1v1H8z"
      />
      <path
        fill="#838383"
        d="M10 12h1v1h-1zM11 12h1v1h-1zM12 12h1v1h-1zM13 12h1v1h-1zM14 12h1v1h-1zM15 12h1v1h-1zM16 12h1v1h-1zM17 12h1v1h-1zM18 12h1v1h-1zM19 12h1v1h-1zM20 12h1v1h-1z"
      />
      <path fill="#E6D9BD" d="M21 12h1v1h-1z" />
      <path fill="#A0A0A0" d="M22 12h1v1h-1zM23 12h1v1h-1zM24 12h1v1h-1z" />
      <path fill="#E6D9BD" d="M25 12h1v1h-1z" />
      <path fill="#838383" d="M26 12h1v1h-1zM27 12h1v1h-1zM28 12h1v1h-1z" />
      <path
        fill="#A0A0A0"
        d="M30 12h1v1h-1zM31 12h1v1h-1zM33 12h1v1h-1zM34 12h1v1h-1zM36 12h1v1h-1z"
      />
      <path
        fill="#E6D9BD"
        d="M10 13h1v1h-1zM11 13h1v1h-1zM12 13h1v1h-1zM13 13h1v1h-1zM14 13h1v1h-1zM15 13h1v1h-1zM16 13h1v1h-1zM17 13h1v1h-1zM18 13h1v1h-1zM19 13h1v1h-1zM20 13h1v1h-1zM21 13h1v1h-1z"
      />
      <path fill="#A0A0A0" d="M22 13h1v1h-1z" />
      <path fill="#E6D9BD" d="M23 13h1v1h-1z" />
      <path fill="#A0A0A0" d="M24 13h1v1h-1z" />
      <path
        fill="#E6D9BD"
        d="M25 13h1v1h-1zM26 13h1v1h-1zM27 13h1v1h-1zM28 13h1v1h-1z"
      />
      <path fill="#A0A0A0" d="M6 14h1v1H6zM8 14h1v1H8z" />
      <path fill="#838383" d="M10 14h1v1h-1z" />
      <path fill="#E6D9BD" d="M11 14h1v1h-1z" />
      <path fill="#A0A0A0" d="M12 14h1v1h-1zM13 14h1v1h-1zM14 14h1v1h-1z" />
      <path fill="#E6D9BD" d="M15 14h1v1h-1z" />
      <path
        fill="#838383"
        d="M16 14h1v1h-1zM17 14h1v1h-1zM18 14h1v1h-1zM19 14h1v1h-1zM20 14h1v1h-1z"
      />
      <path fill="#E6D9BD" d="M21 14h1v1h-1z" />
      <path fill="#A0A0A0" d="M22 14h1v1h-1zM23 14h1v1h-1zM24 14h1v1h-1z" />
      <path fill="#E6D9BD" d="M25 14h1v1h-1z" />
      <path fill="#838383" d="M26 14h1v1h-1zM27 14h1v1h-1zM28 14h1v1h-1z" />
      <path fill="#A0A0A0" d="M30 14h1v1h-1zM32 14h1v1h-1z" />
      <path fill="#E6D9BD" d="M11 15h1v1h-1z" />
      <path fill="#A0A0A0" d="M12 15h1v1h-1z" />
      <path fill="#E6D9BD" d="M13 15h1v1h-1z" />
      <path fill="#A0A0A0" d="M14 15h1v1h-1z" />
      <path
        fill="#E6D9BD"
        d="M15 15h1v1h-1zM16 15h1v1h-1zM17 15h1v1h-1zM18 15h1v1h-1zM19 15h1v1h-1zM20 15h1v1h-1zM21 15h1v1h-1zM22 15h1v1h-1zM23 15h1v1h-1zM24 15h1v1h-1zM25 15h1v1h-1zM26 15h1v1h-1zM27 15h1v1h-1z"
      />
      <path fill="#A0A0A0" d="M8 16h1v1H8zM9 16h1v1H9z" />
      <path fill="#E6D9BD" d="M11 16h1v1h-1z" />
      <path fill="#A0A0A0" d="M12 16h1v1h-1zM13 16h1v1h-1zM14 16h1v1h-1z" />
      <path fill="#E6D9BD" d="M15 16h1v1h-1z" />
      <path
        fill="#838383"
        d="M16 16h1v1h-1zM17 16h1v1h-1zM18 16h1v1h-1zM19 16h1v1h-1zM20 16h1v1h-1zM21 16h1v1h-1zM22 16h1v1h-1zM23 16h1v1h-1zM24 16h1v1h-1zM25 16h1v1h-1zM26 16h1v1h-1zM27 16h1v1h-1z"
      />
      <path fill="#A0A0A0" d="M29 16h1v1h-1zM30 16h1v1h-1z" />
      <path
        fill="#E6D9BD"
        d="M12 17h1v1h-1zM13 17h1v1h-1zM14 17h1v1h-1zM15 17h1v1h-1zM16 17h1v1h-1zM17 17h1v1h-1zM18 17h1v1h-1zM19 17h1v1h-1zM20 17h1v1h-1zM21 17h1v1h-1zM22 17h1v1h-1zM23 17h1v1h-1zM24 17h1v1h-1zM25 17h1v1h-1zM26 17h1v1h-1z"
      />
      <path fill="#A0A0A0" d="M10 18h1v1h-1z" />
      <path
        fill="#838383"
        d="M13 18h1v1h-1zM14 18h1v1h-1zM15 18h1v1h-1zM16 18h1v1h-1zM17 18h1v1h-1zM18 18h1v1h-1z"
      />
      <path fill="#E6D9BD" d="M19 18h1v1h-1z" />
      <path fill="#A0A0A0" d="M20 18h1v1h-1zM21 18h1v1h-1zM22 18h1v1h-1z" />
      <path fill="#E6D9BD" d="M23 18h1v1h-1z" />
      <path fill="#838383" d="M24 18h1v1h-1zM25 18h1v1h-1z" />
      <path fill="#A0A0A0" d="M28 18h1v1h-1z" />
      <path
        fill="#E6D9BD"
        d="M14 19h1v1h-1zM15 19h1v1h-1zM16 19h1v1h-1zM17 19h1v1h-1zM18 19h1v1h-1zM19 19h1v1h-1z"
      />
      <path fill="#A0A0A0" d="M20 19h1v1h-1z" />  
      <path fill="#E6D9BD" d="M21 19h1v1h-1z" />
      <path fill="#A0A0A0" d="M22 19h1v1h-1z" />
      <path fill="#E6D9BD" d="M23 19h1v1h-1zM24 19h1v1h-1z" />
      <path fill="#838383" d="M16 20h1v1h-1zM17 20h1v1h-1zM18 20h1v1h-1z" />
      <path fill="#E6D9BD" d="M19 20h1v1h-1z" />
      <path fill="#A0A0A0" d="M20 20h1v1h-1zM21 20h1v1h-1zM22 20h1v1h-1z" />
      </g>
    </svg>
  )
}

export const Sun2 = (props) => { 
  return (
    <svg
      aria-hidden="true"
      data-prefix="fas"
      data-icon="sun"
      className="prefix__svg-inline--fa prefix__fa-sun prefix__fa-w-20"
      xmlns="http://www.w3.org/2000/svg"
      shapeRendering="crispEdges"
      viewBox="0 0 48 48"
      {...props}
    >
    <g transform="translate(4, 8)">
    <path
      fill="#C87E7E"
      d="M16 4h1v1h-1zM17 4h1v1h-1zM18 4h1v1h-1zM19 4h1v1h-1zM20 4h1v1h-1zM21 4h1v1h-1zM22 4h1v1h-1z"
    />
    <path
      fill="#E6D9BD"
      d="M14 5h1v1h-1zM15 5h1v1h-1zM16 5h1v1h-1zM17 5h1v1h-1zM18 5h1v1h-1zM19 5h1v1h-1zM20 5h1v1h-1zM21 5h1v1h-1zM22 5h1v1h-1zM23 5h1v1h-1zM24 5h1v1h-1z"
    />
    <path
      fill="#CC9970"
      d="M5 6h1v1H5zM7 6h1v1H7zM8 6h1v1H8zM10 6h1v1h-1zM11 6h1v1h-1z"
    />
    <path
      fill="#C87E7E"
      d="M13 6h1v1h-1zM14 6h1v1h-1zM15 6h1v1h-1zM16 6h1v1h-1zM17 6h1v1h-1zM18 6h1v1h-1zM19 6h1v1h-1zM20 6h1v1h-1zM21 6h1v1h-1zM22 6h1v1h-1zM23 6h1v1h-1zM24 6h1v1h-1zM25 6h1v1h-1z"
    />
    <path
      fill="#CC9970"
      d="M27 6h1v1h-1zM28 6h1v1h-1zM30 6h1v1h-1zM31 6h1v1h-1zM33 6h1v1h-1z"
    />
    <path
      fill="#E6D9BD"
      d="M12 7h1v1h-1zM13 7h1v1h-1zM14 7h1v1h-1zM15 7h1v1h-1zM16 7h1v1h-1zM17 7h1v1h-1zM18 7h1v1h-1zM19 7h1v1h-1zM20 7h1v1h-1zM21 7h1v1h-1zM22 7h1v1h-1zM23 7h1v1h-1zM24 7h1v1h-1zM25 7h1v1h-1zM26 7h1v1h-1z"
    />
    <path fill="#CC9970" d="M9 8h1v1H9z" />
    <path
      fill="#C87E7E"
      d="M11 8h1v1h-1zM12 8h1v1h-1zM13 8h1v1h-1zM14 8h1v1h-1zM15 8h1v1h-1zM16 8h1v1h-1zM17 8h1v1h-1zM18 8h1v1h-1zM19 8h1v1h-1zM20 8h1v1h-1zM21 8h1v1h-1zM22 8h1v1h-1zM23 8h1v1h-1zM24 8h1v1h-1zM25 8h1v1h-1zM26 8h1v1h-1zM27 8h1v1h-1z"
    />
    <path fill="#CC9970" d="M29 8h1v1h-1z" />
    <path
      fill="#E6D9BD"
      d="M11 9h1v1h-1zM12 9h1v1h-1zM13 9h1v1h-1zM14 9h1v1h-1zM15 9h1v1h-1zM16 9h1v1h-1zM17 9h1v1h-1zM18 9h1v1h-1zM19 9h1v1h-1zM20 9h1v1h-1zM21 9h1v1h-1zM22 9h1v1h-1zM23 9h1v1h-1zM24 9h1v1h-1zM25 9h1v1h-1zM26 9h1v1h-1zM27 9h1v1h-1z"
    />
    <path fill="#CC9970" d="M6 10h1v1H6zM8 10h1v1H8z" />
    <path
      fill="#C87E7E"
      d="M10 10h1v1h-1zM11 10h1v1h-1zM12 10h1v1h-1zM13 10h1v1h-1zM14 10h1v1h-1zM15 10h1v1h-1zM16 10h1v1h-1zM17 10h1v1h-1zM18 10h1v1h-1zM19 10h1v1h-1zM20 10h1v1h-1zM21 10h1v1h-1zM22 10h1v1h-1zM23 10h1v1h-1zM24 10h1v1h-1zM25 10h1v1h-1zM26 10h1v1h-1zM27 10h1v1h-1zM28 10h1v1h-1z"
    />
    <path fill="#CC9970" d="M30 10h1v1h-1zM32 10h1v1h-1z" />
    <path
      fill="#E6D9BD"
      d="M10 11h1v1h-1zM11 11h1v1h-1zM12 11h1v1h-1zM13 11h1v1h-1zM14 11h1v1h-1zM15 11h1v1h-1zM16 11h1v1h-1zM17 11h1v1h-1zM18 11h1v1h-1zM19 11h1v1h-1zM20 11h1v1h-1zM21 11h1v1h-1zM22 11h1v1h-1zM23 11h1v1h-1zM24 11h1v1h-1zM25 11h1v1h-1zM26 11h1v1h-1zM27 11h1v1h-1zM28 11h1v1h-1z"
    />
    <path
      fill="#CC9970"
      d="M2 12h1v1H2zM4 12h1v1H4zM5 12h1v1H5zM7 12h1v1H7zM8 12h1v1H8z"
    />
    <path
      fill="#C87E7E"
      d="M10 12h1v1h-1zM11 12h1v1h-1zM12 12h1v1h-1zM13 12h1v1h-1zM14 12h1v1h-1zM15 12h1v1h-1zM16 12h1v1h-1zM17 12h1v1h-1zM18 12h1v1h-1zM19 12h1v1h-1zM20 12h1v1h-1zM21 12h1v1h-1zM22 12h1v1h-1zM23 12h1v1h-1zM24 12h1v1h-1zM25 12h1v1h-1zM26 12h1v1h-1zM27 12h1v1h-1zM28 12h1v1h-1z"
    />
    <path
      fill="#CC9970"
      d="M30 12h1v1h-1zM31 12h1v1h-1zM33 12h1v1h-1zM34 12h1v1h-1zM36 12h1v1h-1z"
    />
    <path
      fill="#E6D9BD"
      d="M10 13h1v1h-1zM11 13h1v1h-1zM12 13h1v1h-1zM13 13h1v1h-1zM14 13h1v1h-1zM15 13h1v1h-1zM16 13h1v1h-1zM17 13h1v1h-1zM18 13h1v1h-1zM19 13h1v1h-1zM20 13h1v1h-1zM21 13h1v1h-1zM22 13h1v1h-1zM23 13h1v1h-1zM24 13h1v1h-1zM25 13h1v1h-1zM26 13h1v1h-1zM27 13h1v1h-1zM28 13h1v1h-1z"
    />
    <path fill="#CC9970" d="M6 14h1v1H6zM8 14h1v1H8z" />
    <path
      fill="#C87E7E"
      d="M10 14h1v1h-1zM11 14h1v1h-1zM12 14h1v1h-1zM13 14h1v1h-1zM14 14h1v1h-1zM15 14h1v1h-1zM16 14h1v1h-1zM17 14h1v1h-1zM18 14h1v1h-1zM19 14h1v1h-1zM20 14h1v1h-1zM21 14h1v1h-1zM22 14h1v1h-1zM23 14h1v1h-1zM24 14h1v1h-1zM25 14h1v1h-1zM26 14h1v1h-1zM27 14h1v1h-1zM28 14h1v1h-1z"
    />
    <path fill="#CC9970" d="M30 14h1v1h-1zM32 14h1v1h-1z" />
    <path
      fill="#E6D9BD"
      d="M11 15h1v1h-1zM12 15h1v1h-1zM13 15h1v1h-1zM14 15h1v1h-1zM15 15h1v1h-1zM16 15h1v1h-1zM17 15h1v1h-1zM18 15h1v1h-1zM19 15h1v1h-1zM20 15h1v1h-1zM21 15h1v1h-1zM22 15h1v1h-1zM23 15h1v1h-1zM24 15h1v1h-1zM25 15h1v1h-1zM26 15h1v1h-1zM27 15h1v1h-1z"
    />
    <path fill="#CC9970" d="M9 16h1v1H9z" />
    <path
      fill="#C87E7E"
      d="M11 16h1v1h-1zM12 16h1v1h-1zM13 16h1v1h-1zM14 16h1v1h-1zM15 16h1v1h-1zM16 16h1v1h-1zM17 16h1v1h-1zM18 16h1v1h-1zM19 16h1v1h-1zM20 16h1v1h-1zM21 16h1v1h-1zM22 16h1v1h-1zM23 16h1v1h-1zM24 16h1v1h-1zM25 16h1v1h-1zM26 16h1v1h-1zM27 16h1v1h-1z"
    />
    <path fill="#CC9970" d="M29 16h1v1h-1z" />
    <path
      fill="#E6D9BD"
      d="M12 17h1v1h-1zM13 17h1v1h-1zM14 17h1v1h-1zM15 17h1v1h-1zM16 17h1v1h-1zM17 17h1v1h-1zM18 17h1v1h-1zM19 17h1v1h-1zM20 17h1v1h-1zM21 17h1v1h-1zM22 17h1v1h-1zM23 17h1v1h-1zM24 17h1v1h-1zM25 17h1v1h-1zM26 17h1v1h-1z"
    />
    <path
      fill="#CC9970"
      d="M5 18h1v1H5zM7 18h1v1H7zM8 18h1v1H8zM10 18h1v1h-1zM11 18h1v1h-1z"
    />
    <path
      fill="#C87E7E"
      d="M13 18h1v1h-1zM14 18h1v1h-1zM15 18h1v1h-1zM16 18h1v1h-1zM17 18h1v1h-1zM18 18h1v1h-1zM19 18h1v1h-1zM20 18h1v1h-1zM21 18h1v1h-1zM22 18h1v1h-1zM23 18h1v1h-1zM24 18h1v1h-1zM25 18h1v1h-1z"
    />
    <path
      fill="#CC9970"
      d="M27 18h1v1h-1zM28 18h1v1h-1zM30 18h1v1h-1zM31 18h1v1h-1zM33 18h1v1h-1z"
    />
    <path
      fill="#E6D9BD"
      d="M14 19h1v1h-1zM15 19h1v1h-1zM16 19h1v1h-1zM17 19h1v1h-1zM18 19h1v1h-1zM19 19h1v1h-1zM20 19h1v1h-1zM21 19h1v1h-1zM22 19h1v1h-1zM23 19h1v1h-1zM24 19h1v1h-1z"
    />
    <path
      fill="#C87E7E"
      d="M16 20h1v1h-1zM17 20h1v1h-1zM18 20h1v1h-1zM19 20h1v1h-1zM20 20h1v1h-1zM21 20h1v1h-1zM22 20h1v1h-1z"
    />
    </g>
  </svg>
  )
}

export const CloudBigLight1 = (props) => { 
  return (
    <svg
      aria-hidden="true"
      data-prefix="fas"
      data-icon="cloud-big-light"
      className="prefix__svg-inline--fa prefix__fa-cloud-big-light prefix__fa-w-20"
      xmlns="http://www.w3.org/2000/svg"
      shapeRendering="crispEdges"
      viewBox="0 0 32 16"
      {...props}
    >
      <path
        fill="#839CA9"
        d="M9 2h1v1H9zM10 2h1v1h-1zM11 2h1v1h-1zM12 2h1v1h-1zM7 3h1v1H7zM8 3h1v1H8zM9 3h1v1H9zM12 3h1v1h-1zM13 3h1v1h-1zM14 3h1v1h-1zM17 3h1v1h-1zM18 3h1v1h-1zM19 3h1v1h-1zM4 4h1v1H4zM5 4h1v1H5zM6 4h1v1H6zM7 4h1v1H7zM14 4h1v1h-1zM15 4h1v1h-1zM16 4h1v1h-1zM17 4h1v1h-1zM19 4h1v1h-1zM20 4h1v1h-1zM21 4h1v1h-1zM22 4h1v1h-1zM24 4h1v1h-1zM25 4h1v1h-1zM26 4h1v1h-1zM3 5h1v1H3zM4 5h1v1H4zM22 5h1v1h-1zM23 5h1v1h-1zM24 5h1v1h-1zM26 5h1v1h-1zM27 5h1v1h-1zM2 6h1v1H2zM3 6h1v1H3zM27 6h1v1h-1zM28 6h1v1h-1zM29 6h1v1h-1zM2 7h1v1H2zM29 7h1v1h-1zM30 7h1v1h-1zM2 8h1v1H2zM30 8h1v1h-1zM2 9h1v1H2zM3 9h1v1H3zM30 9h1v1h-1zM3 10h1v1H3zM4 10h1v1H4zM5 10h1v1H5zM6 10h1v1H6zM29 10h1v1h-1zM30 10h1v1h-1zM6 11h1v1H6zM7 11h1v1H7zM8 11h1v1H8zM13 11h1v1h-1zM14 11h1v1h-1zM15 11h1v1h-1zM16 11h1v1h-1zM21 11h1v1h-1zM22 11h1v1h-1zM23 11h1v1h-1zM24 11h1v1h-1zM26 11h1v1h-1zM27 11h1v1h-1zM28 11h1v1h-1zM29 11h1v1h-1zM8 12h1v1H8zM9 12h1v1H9zM10 12h1v1h-1zM11 12h1v1h-1zM12 12h1v1h-1zM13 12h1v1h-1zM16 12h1v1h-1zM17 12h1v1h-1zM18 12h1v1h-1zM19 12h1v1h-1zM20 12h1v1h-1zM21 12h1v1h-1zM24 12h1v1h-1zM25 12h1v1h-1zM26 12h1v1h-1z"
    />
    </svg>    
  )
}

export const CloudBigLight2 = (props) => { 
  return (
    <svg
      aria-hidden="true"
      data-prefix="fas"
      data-icon="cloud-big-light"
      className="prefix__svg-inline--fa prefix__fa-cloud-big-light prefix__fa-w-20"
      xmlns="http://www.w3.org/2000/svg"
      shapeRendering="crispEdges"
      viewBox="0 0 32 16"
      {...props}
    >
      <path
        fill="#839CA9"
        d="M12 2h1v1h-1zM13 2h1v1h-1zM14 2h1v1h-1zM15 2h1v1h-1zM17 2h1v1h-1zM18 2h1v1h-1zM19 2h1v1h-1zM20 2h1v1h-1zM21 2h1v1h-1zM5 3h1v1H5zM6 3h1v1H6zM7 3h1v1H7zM8 3h1v1H8zM10 3h1v1h-1zM11 3h1v1h-1zM12 3h1v1h-1zM15 3h1v1h-1zM16 3h1v1h-1zM17 3h1v1h-1zM21 3h1v1h-1zM22 3h1v1h-1zM23 3h1v1h-1zM25 3h1v1h-1zM26 3h1v1h-1zM27 3h1v1h-1zM3 4h1v1H3zM4 4h1v1H4zM5 4h1v1H5zM8 4h1v1H8zM9 4h1v1H9zM10 4h1v1h-1zM23 4h1v1h-1zM24 4h1v1h-1zM25 4h1v1h-1zM27 4h1v1h-1zM28 4h1v1h-1zM29 4h1v1h-1zM2 5h1v1H2zM3 5h1v1H3zM29 5h1v1h-1zM30 5h1v1h-1zM1 6h1v1H1zM2 6h1v1H2zM30 6h1v1h-1zM31 6h1v1h-1zM1 7h1v1H1zM31 7h1v1h-1zM1 8h1v1H1zM2 8h1v1H2zM30 8h1v1h-1zM31 8h1v1h-1zM2 9h1v1H2zM3 9h1v1H3zM4 9h1v1H4zM29 9h1v1h-1zM30 9h1v1h-1zM4 10h1v1H4zM5 10h1v1H5zM6 10h1v1H6zM8 10h1v1H8zM9 10h1v1H9zM10 10h1v1h-1zM14 10h1v1h-1zM15 10h1v1h-1zM16 10h1v1h-1zM17 10h1v1h-1zM18 10h1v1h-1zM21 10h1v1h-1zM22 10h1v1h-1zM23 10h1v1h-1zM24 10h1v1h-1zM27 10h1v1h-1zM28 10h1v1h-1zM29 10h1v1h-1zM6 11h1v1H6zM7 11h1v1H7zM8 11h1v1H8zM10 11h1v1h-1zM11 11h1v1h-1zM12 11h1v1h-1zM13 11h1v1h-1zM14 11h1v1h-1zM18 11h1v1h-1zM19 11h1v1h-1zM20 11h1v1h-1zM21 11h1v1h-1zM24 11h1v1h-1zM25 11h1v1h-1zM26 11h1v1h-1zM27 11h1v1h-1z"
      />
    </svg>    
  )
}

export const CloudBigLight3 = (props) => { 
  return (
    <svg
      aria-hidden="true"
      data-prefix="fas"
      data-icon="cloud-big-light"
      className="prefix__svg-inline--fa prefix__fa-cloud-big-light prefix__fa-w-20"
      xmlns="http://www.w3.org/2000/svg"
      shapeRendering="crispEdges"
      viewBox="0 0 32 16"
      {...props}
    >
    <path
      fill="#839CA9"
      d="M16 2h1v1h-1zM17 2h1v1h-1zM18 2h1v1h-1zM19 2h1v1h-1zM14 3h1v1h-1zM15 3h1v1h-1zM16 3h1v1h-1zM19 3h1v1h-1zM20 3h1v1h-1zM21 3h1v1h-1zM22 3h1v1h-1zM24 3h1v1h-1zM25 3h1v1h-1zM26 3h1v1h-1zM8 4h1v1H8zM9 4h1v1H9zM10 4h1v1h-1zM12 4h1v1h-1zM13 4h1v1h-1zM14 4h1v1h-1zM22 4h1v1h-1zM23 4h1v1h-1zM24 4h1v1h-1zM26 4h1v1h-1zM27 4h1v1h-1zM28 4h1v1h-1zM6 5h1v1H6zM7 5h1v1H7zM8 5h1v1H8zM10 5h1v1h-1zM11 5h1v1h-1zM12 5h1v1h-1zM28 5h1v1h-1zM29 5h1v1h-1zM4 6h1v1H4zM5 6h1v1H5zM6 6h1v1H6zM29 6h1v1h-1zM30 6h1v1h-1zM3 7h1v1H3zM4 7h1v1H4zM30 7h1v1h-1zM3 8h1v1H3zM29 8h1v1h-1zM30 8h1v1h-1zM3 9h1v1H3zM4 9h1v1H4zM22 9h1v1h-1zM23 9h1v1h-1zM24 9h1v1h-1zM25 9h1v1h-1zM28 9h1v1h-1zM29 9h1v1h-1zM4 10h1v1H4zM5 10h1v1H5zM6 10h1v1H6zM7 10h1v1H7zM10 10h1v1h-1zM11 10h1v1h-1zM12 10h1v1h-1zM13 10h1v1h-1zM19 10h1v1h-1zM20 10h1v1h-1zM21 10h1v1h-1zM22 10h1v1h-1zM25 10h1v1h-1zM26 10h1v1h-1zM27 10h1v1h-1zM28 10h1v1h-1zM7 11h1v1H7zM8 11h1v1H8zM9 11h1v1H9zM10 11h1v1h-1zM13 11h1v1h-1zM14 11h1v1h-1zM17 11h1v1h-1zM18 11h1v1h-1zM19 11h1v1h-1zM14 12h1v1h-1zM15 12h1v1h-1zM16 12h1v1h-1zM17 12h1v1h-1z"
    />
    </svg>    
  )
}

export const CloudBigLight4 = (props) => { 
  return (
    <svg
      aria-hidden="true"
      data-prefix="fas"
      data-icon="cloud-big-light"
      className="prefix__svg-inline--fa prefix__fa-cloud-big-light prefix__fa-w-20"
      xmlns="http://www.w3.org/2000/svg"
      shapeRendering="crispEdges"
      viewBox="0 0 32 16"
      {...props}
    >
    <path
      fill="#839CA9"
      d="M10 3h1v1h-1zM11 3h1v1h-1zM12 3h1v1h-1zM13 3h1v1h-1zM7 4h1v1H7zM8 4h1v1H8zM9 4h1v1H9zM10 4h1v1h-1zM13 4h1v1h-1zM14 4h1v1h-1zM15 4h1v1h-1zM18 4h1v1h-1zM19 4h1v1h-1zM20 4h1v1h-1zM21 4h1v1h-1zM22 4h1v1h-1zM5 5h1v1H5zM6 5h1v1H6zM7 5h1v1H7zM15 5h1v1h-1zM16 5h1v1h-1zM17 5h1v1h-1zM18 5h1v1h-1zM22 5h1v1h-1zM23 5h1v1h-1zM24 5h1v1h-1zM25 5h1v1h-1zM4 6h1v1H4zM5 6h1v1H5zM25 6h1v1h-1zM26 6h1v1h-1zM27 6h1v1h-1zM28 6h1v1h-1zM4 7h1v1H4zM28 7h1v1h-1zM29 7h1v1h-1zM4 8h1v1H4zM29 8h1v1h-1zM4 9h1v1H4zM5 9h1v1H5zM6 9h1v1H6zM28 9h1v1h-1zM29 9h1v1h-1zM6 10h1v1H6zM7 10h1v1H7zM8 10h1v1H8zM11 10h1v1h-1zM12 10h1v1h-1zM13 10h1v1h-1zM14 10h1v1h-1zM21 10h1v1h-1zM22 10h1v1h-1zM23 10h1v1h-1zM24 10h1v1h-1zM26 10h1v1h-1zM27 10h1v1h-1zM28 10h1v1h-1zM8 11h1v1H8zM9 11h1v1H9zM10 11h1v1h-1zM11 11h1v1h-1zM14 11h1v1h-1zM15 11h1v1h-1zM18 11h1v1h-1zM19 11h1v1h-1zM20 11h1v1h-1zM21 11h1v1h-1zM24 11h1v1h-1zM25 11h1v1h-1zM26 11h1v1h-1zM15 12h1v1h-1zM16 12h1v1h-1zM17 12h1v1h-1zM18 12h1v1h-1z"
    />
    </svg>    
  )
}

export const CloudBigDark1 = (props) => { 
  return (
    <svg
      aria-hidden="true"
      data-prefix="fas"
      data-icon="cloud-big-dark"
      className="prefix__svg-inline--fa prefix__fa-cloud-big-dark prefix__fa-w-20"
      xmlns="http://www.w3.org/2000/svg"
      shapeRendering="crispEdges"
      viewBox="0 0 31 16"
      {...props}
    >
      <path
      fill="#6D838E"
      d="M9 2h1v1H9zM10 2h1v1h-1zM11 2h1v1h-1zM12 2h1v1h-1zM7 3h1v1H7zM8 3h1v1H8zM9 3h1v1H9zM12 3h1v1h-1zM13 3h1v1h-1zM14 3h1v1h-1zM17 3h1v1h-1zM18 3h1v1h-1zM19 3h1v1h-1zM4 4h1v1H4zM5 4h1v1H5zM6 4h1v1H6zM7 4h1v1H7zM14 4h1v1h-1zM15 4h1v1h-1zM16 4h1v1h-1zM17 4h1v1h-1zM19 4h1v1h-1zM20 4h1v1h-1zM21 4h1v1h-1zM22 4h1v1h-1zM24 4h1v1h-1zM25 4h1v1h-1zM26 4h1v1h-1zM3 5h1v1H3zM4 5h1v1H4zM22 5h1v1h-1zM23 5h1v1h-1zM24 5h1v1h-1zM26 5h1v1h-1zM27 5h1v1h-1zM2 6h1v1H2zM3 6h1v1H3zM27 6h1v1h-1zM28 6h1v1h-1zM29 6h1v1h-1zM2 7h1v1H2zM29 7h1v1h-1zM30 7h1v1h-1zM2 8h1v1H2zM30 8h1v1h-1zM2 9h1v1H2zM3 9h1v1H3zM30 9h1v1h-1zM3 10h1v1H3zM4 10h1v1H4zM5 10h1v1H5zM6 10h1v1H6zM29 10h1v1h-1zM30 10h1v1h-1zM6 11h1v1H6zM7 11h1v1H7zM8 11h1v1H8zM13 11h1v1h-1zM14 11h1v1h-1zM15 11h1v1h-1zM16 11h1v1h-1zM21 11h1v1h-1zM22 11h1v1h-1zM23 11h1v1h-1zM24 11h1v1h-1zM26 11h1v1h-1zM27 11h1v1h-1zM28 11h1v1h-1zM29 11h1v1h-1zM8 12h1v1H8zM9 12h1v1H9zM10 12h1v1h-1zM11 12h1v1h-1zM12 12h1v1h-1zM13 12h1v1h-1zM16 12h1v1h-1zM17 12h1v1h-1zM18 12h1v1h-1zM19 12h1v1h-1zM20 12h1v1h-1zM21 12h1v1h-1zM24 12h1v1h-1zM25 12h1v1h-1zM26 12h1v1h-1z"
    />
    </svg>    
  )
}

export const CloudBigDark2 = (props) => { 
  return (
    <svg
      aria-hidden="true"
      data-prefix="fas"
      data-icon="cloud-big-dark"
      className="prefix__svg-inline--fa prefix__fa-cloud-big-dark prefix__fa-w-20"
      xmlns="http://www.w3.org/2000/svg"
      shapeRendering="crispEdges"
      viewBox="0 0 31 16"
      {...props}
    >
    <path
      fill="#6D838E"
      d="M12 2h1v1h-1zM13 2h1v1h-1zM14 2h1v1h-1zM15 2h1v1h-1zM17 2h1v1h-1zM18 2h1v1h-1zM19 2h1v1h-1zM20 2h1v1h-1zM21 2h1v1h-1zM5 3h1v1H5zM6 3h1v1H6zM7 3h1v1H7zM8 3h1v1H8zM10 3h1v1h-1zM11 3h1v1h-1zM12 3h1v1h-1zM15 3h1v1h-1zM16 3h1v1h-1zM17 3h1v1h-1zM21 3h1v1h-1zM22 3h1v1h-1zM23 3h1v1h-1zM25 3h1v1h-1zM26 3h1v1h-1zM27 3h1v1h-1zM3 4h1v1H3zM4 4h1v1H4zM5 4h1v1H5zM8 4h1v1H8zM9 4h1v1H9zM10 4h1v1h-1zM23 4h1v1h-1zM24 4h1v1h-1zM25 4h1v1h-1zM27 4h1v1h-1zM28 4h1v1h-1zM29 4h1v1h-1zM2 5h1v1H2zM3 5h1v1H3zM29 5h1v1h-1zM30 5h1v1h-1zM1 6h1v1H1zM2 6h1v1H2zM30 6h1v1h-1zM1 7h1v1H1zM1 8h1v1H1zM2 8h1v1H2zM30 8h1v1h-1zM2 9h1v1H2zM3 9h1v1H3zM4 9h1v1H4zM29 9h1v1h-1zM30 9h1v1h-1zM4 10h1v1H4zM5 10h1v1H5zM6 10h1v1H6zM8 10h1v1H8zM9 10h1v1H9zM10 10h1v1h-1zM14 10h1v1h-1zM15 10h1v1h-1zM16 10h1v1h-1zM17 10h1v1h-1zM18 10h1v1h-1zM21 10h1v1h-1zM22 10h1v1h-1zM23 10h1v1h-1zM24 10h1v1h-1zM27 10h1v1h-1zM28 10h1v1h-1zM29 10h1v1h-1zM6 11h1v1H6zM7 11h1v1H7zM8 11h1v1H8zM10 11h1v1h-1zM11 11h1v1h-1zM12 11h1v1h-1zM13 11h1v1h-1zM14 11h1v1h-1zM18 11h1v1h-1zM19 11h1v1h-1zM20 11h1v1h-1zM21 11h1v1h-1zM24 11h1v1h-1zM25 11h1v1h-1zM26 11h1v1h-1zM27 11h1v1h-1z"
    />
    </svg>    
  )
}

export const CloudBigDark3 = (props) => { 
  return (
    <svg
      aria-hidden="true"
      data-prefix="fas"
      data-icon="cloud-big-dark"
      className="prefix__svg-inline--fa prefix__fa-cloud-big-dark prefix__fa-w-20"
      xmlns="http://www.w3.org/2000/svg"
      shapeRendering="crispEdges"
      viewBox="0 0 31 16"
      {...props}
    >
    <path
      fill="#6D838E"
      d="M16 2h1v1h-1zM17 2h1v1h-1zM18 2h1v1h-1zM19 2h1v1h-1zM14 3h1v1h-1zM15 3h1v1h-1zM16 3h1v1h-1zM19 3h1v1h-1zM20 3h1v1h-1zM21 3h1v1h-1zM22 3h1v1h-1zM24 3h1v1h-1zM25 3h1v1h-1zM26 3h1v1h-1zM8 4h1v1H8zM9 4h1v1H9zM10 4h1v1h-1zM12 4h1v1h-1zM13 4h1v1h-1zM14 4h1v1h-1zM22 4h1v1h-1zM23 4h1v1h-1zM24 4h1v1h-1zM26 4h1v1h-1zM27 4h1v1h-1zM28 4h1v1h-1zM6 5h1v1H6zM7 5h1v1H7zM8 5h1v1H8zM10 5h1v1h-1zM11 5h1v1h-1zM12 5h1v1h-1zM28 5h1v1h-1zM29 5h1v1h-1zM4 6h1v1H4zM5 6h1v1H5zM6 6h1v1H6zM29 6h1v1h-1zM30 6h1v1h-1zM3 7h1v1H3zM4 7h1v1H4zM30 7h1v1h-1zM3 8h1v1H3zM29 8h1v1h-1zM30 8h1v1h-1zM3 9h1v1H3zM4 9h1v1H4zM22 9h1v1h-1zM23 9h1v1h-1zM24 9h1v1h-1zM25 9h1v1h-1zM28 9h1v1h-1zM29 9h1v1h-1zM4 10h1v1H4zM5 10h1v1H5zM6 10h1v1H6zM7 10h1v1H7zM10 10h1v1h-1zM11 10h1v1h-1zM12 10h1v1h-1zM13 10h1v1h-1zM19 10h1v1h-1zM20 10h1v1h-1zM21 10h1v1h-1zM22 10h1v1h-1zM25 10h1v1h-1zM26 10h1v1h-1zM27 10h1v1h-1zM28 10h1v1h-1zM7 11h1v1H7zM8 11h1v1H8zM9 11h1v1H9zM10 11h1v1h-1zM13 11h1v1h-1zM14 11h1v1h-1zM17 11h1v1h-1zM18 11h1v1h-1zM19 11h1v1h-1zM14 12h1v1h-1zM15 12h1v1h-1zM16 12h1v1h-1zM17 12h1v1h-1z"
    />
    </svg>    
  )
}

export const CloudBigDark4 = (props) => { 
  return (
    <svg
      aria-hidden="true"
      data-prefix="fas"
      data-icon="cloud-big-dark"
      className="prefix__svg-inline--fa prefix__fa-cloud-big-dark prefix__fa-w-20"
      xmlns="http://www.w3.org/2000/svg"
      shapeRendering="crispEdges"
      viewBox="0 0 31 16"
      {...props}
    >
    <path
      fill="#6D838E"
      d="M10 3h1v1h-1zM11 3h1v1h-1zM12 3h1v1h-1zM13 3h1v1h-1zM7 4h1v1H7zM8 4h1v1H8zM9 4h1v1H9zM10 4h1v1h-1zM13 4h1v1h-1zM14 4h1v1h-1zM15 4h1v1h-1zM18 4h1v1h-1zM19 4h1v1h-1zM20 4h1v1h-1zM21 4h1v1h-1zM22 4h1v1h-1zM5 5h1v1H5zM6 5h1v1H6zM7 5h1v1H7zM15 5h1v1h-1zM16 5h1v1h-1zM17 5h1v1h-1zM18 5h1v1h-1zM22 5h1v1h-1zM23 5h1v1h-1zM24 5h1v1h-1zM25 5h1v1h-1zM4 6h1v1H4zM5 6h1v1H5zM25 6h1v1h-1zM26 6h1v1h-1zM27 6h1v1h-1zM28 6h1v1h-1zM4 7h1v1H4zM28 7h1v1h-1zM29 7h1v1h-1zM4 8h1v1H4zM29 8h1v1h-1zM4 9h1v1H4zM5 9h1v1H5zM6 9h1v1H6zM28 9h1v1h-1zM29 9h1v1h-1zM6 10h1v1H6zM7 10h1v1H7zM8 10h1v1H8zM11 10h1v1h-1zM12 10h1v1h-1zM13 10h1v1h-1zM14 10h1v1h-1zM21 10h1v1h-1zM22 10h1v1h-1zM23 10h1v1h-1zM24 10h1v1h-1zM26 10h1v1h-1zM27 10h1v1h-1zM28 10h1v1h-1zM8 11h1v1H8zM9 11h1v1H9zM10 11h1v1h-1zM11 11h1v1h-1zM14 11h1v1h-1zM15 11h1v1h-1zM18 11h1v1h-1zM19 11h1v1h-1zM20 11h1v1h-1zM21 11h1v1h-1zM24 11h1v1h-1zM25 11h1v1h-1zM26 11h1v1h-1zM15 12h1v1h-1zM16 12h1v1h-1zM17 12h1v1h-1zM18 12h1v1h-1z"
    />
    </svg>    
  )
}

export const CloudSmallDark1 = (props) => {
  return (
    <svg
      aria-hidden="true"
      data-prefix="fas"
      data-icon="cloud-small-dark"
      className="prefix__svg-inline--fa prefix__fa-cloud-small-dark prefix__fa-w-20"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 31 16"
      shapeRendering="crispEdges"
      {...props}
    >
      <path
        fill="#6D838E"
        d="M6 3h1v1H6zM7 3h1v1H7zM8 3h1v1H8zM9 3h1v1H9zM3 4h1v1H3zM4 4h1v1H4zM5 4h1v1H5zM6 4h1v1H6zM9 4h1v1H9zM10 4h1v1h-1zM11 4h1v1h-1zM13 4h1v1h-1zM14 4h1v1h-1zM15 4h1v1h-1zM16 4h1v1h-1zM17 4h1v1h-1zM2 5h1v1H2zM3 5h1v1H3zM11 5h1v1h-1zM12 5h1v1h-1zM13 5h1v1h-1zM17 5h1v1h-1zM18 5h1v1h-1zM1 6h1v1H1zM2 6h1v1H2zM18 6h1v1h-1zM19 6h1v1h-1zM20 6h1v1h-1zM1 7h1v1H1zM20 7h1v1h-1zM21 7h1v1h-1zM1 8h1v1H1zM21 8h1v1h-1zM1 9h1v1H1zM2 9h1v1H2zM21 9h1v1h-1zM2 10h1v1H2zM3 10h1v1H3zM4 10h1v1H4zM5 10h1v1H5zM20 10h1v1h-1zM21 10h1v1h-1zM5 11h1v1H5zM6 11h1v1H6zM7 11h1v1H7zM11 11h1v1h-1zM12 11h1v1h-1zM13 11h1v1h-1zM14 11h1v1h-1zM17 11h1v1h-1zM18 11h1v1h-1zM19 11h1v1h-1zM20 11h1v1h-1zM7 12h1v1H7zM8 12h1v1H8zM9 12h1v1H9zM10 12h1v1h-1zM11 12h1v1h-1zM14 12h1v1h-1zM15 12h1v1h-1zM16 12h1v1h-1zM17 12h1v1h-1z"
      />
    </svg>
  )
}

export const CloudSmallDark2 = (props) => {
  return (
    <svg
      aria-hidden="true"
      data-prefix="fas"
      data-icon="cloud-small-dark"
      className="prefix__svg-inline--fa prefix__fa-cloud-small-dark prefix__fa-w-20"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 31 16"
      shapeRendering="crispEdges"
      {...props}
    >
      <path
        fill="#6D838E"
        d="M10 3h1v1h-1zM11 3h1v1h-1zM12 3h1v1h-1zM13 3h1v1h-1zM5 4h1v1H5zM6 4h1v1H6zM7 4h1v1H7zM9 4h1v1H9zM10 4h1v1h-1zM13 4h1v1h-1zM14 4h1v1h-1zM16 4h1v1h-1zM17 4h1v1h-1zM18 4h1v1h-1zM19 4h1v1h-1zM3 5h1v1H3zM4 5h1v1H4zM5 5h1v1H5zM7 5h1v1H7zM8 5h1v1H8zM9 5h1v1H9zM14 5h1v1h-1zM15 5h1v1h-1zM16 5h1v1h-1zM19 5h1v1h-1zM20 5h1v1h-1zM2 6h1v1H2zM3 6h1v1H3zM20 6h1v1h-1zM21 6h1v1h-1zM1 7h1v1H1zM2 7h1v1H2zM21 7h1v1h-1zM22 7h1v1h-1zM1 8h1v1H1zM22 8h1v1h-1zM1 9h1v1H1zM22 9h1v1h-1zM1 10h1v1H1zM2 10h1v1H2zM21 10h1v1h-1zM22 10h1v1h-1zM2 11h1v1H2zM3 11h1v1H3zM4 11h1v1H4zM5 11h1v1H5zM7 11h1v1H7zM8 11h1v1H8zM9 11h1v1H9zM13 11h1v1h-1zM14 11h1v1h-1zM15 11h1v1h-1zM16 11h1v1h-1zM19 11h1v1h-1zM20 11h1v1h-1zM21 11h1v1h-1zM5 12h1v1H5zM6 12h1v1H6zM7 12h1v1H7zM9 12h1v1H9zM10 12h1v1h-1zM11 12h1v1h-1zM12 12h1v1h-1zM13 12h1v1h-1zM16 12h1v1h-1zM17 12h1v1h-1zM18 12h1v1h-1zM19 12h1v1h-1z"
      />
    </svg>
  )
}

export const CloudSmallDark3 = (props) => {
  return (
    <svg
      aria-hidden="true"
      data-prefix="fas"
      data-icon="cloud-small-dark"
      className="prefix__svg-inline--fa prefix__fa-cloud-small-dark prefix__fa-w-20"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 31 16"
      shapeRendering="crispEdges"
      {...props}
    >
      <path
        fill="#6D838E"
        d="M12 3h1v1h-1zM13 3h1v1h-1zM14 3h1v1h-1zM15 3h1v1h-1zM6 4h1v1H6zM7 4h1v1H7zM8 4h1v1H8zM10 4h1v1h-1zM11 4h1v1h-1zM12 4h1v1h-1zM15 4h1v1h-1zM16 4h1v1h-1zM17 4h1v1h-1zM3 5h1v1H3zM4 5h1v1H4zM5 5h1v1H5zM6 5h1v1H6zM8 5h1v1H8zM9 5h1v1H9zM10 5h1v1h-1zM17 5h1v1h-1zM18 5h1v1h-1zM19 5h1v1h-1zM20 5h1v1h-1zM2 6h1v1H2zM3 6h1v1H3zM20 6h1v1h-1zM21 6h1v1h-1zM2 7h1v1H2zM21 7h1v1h-1zM22 7h1v1h-1zM2 8h1v1H2zM3 8h1v1H3zM22 8h1v1h-1zM3 9h1v1H3zM4 9h1v1H4zM8 9h1v1H8zM9 9h1v1H9zM10 9h1v1h-1zM11 9h1v1h-1zM21 9h1v1h-1zM22 9h1v1h-1zM4 10h1v1H4zM5 10h1v1H5zM6 10h1v1H6zM7 10h1v1H7zM8 10h1v1H8zM11 10h1v1h-1zM12 10h1v1h-1zM13 10h1v1h-1zM18 10h1v1h-1zM19 10h1v1h-1zM20 10h1v1h-1zM21 10h1v1h-1zM13 11h1v1h-1zM14 11h1v1h-1zM15 11h1v1h-1zM16 11h1v1h-1zM17 11h1v1h-1zM18 11h1v1h-1z"
      />
    </svg>
  )
}

export const CloudSmallDark4 = (props) => {
  return (
    <svg
      aria-hidden="true"
      data-prefix="fas"
      data-icon="cloud-small-dark"
      className="prefix__svg-inline--fa prefix__fa-cloud-small-dark prefix__fa-w-20"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 31 16"
      shapeRendering="crispEdges"
      {...props}
    >
      <path
        fill="#6D838E"
        d="M8 3h1v1H8zM9 3h1v1H9zM10 3h1v1h-1zM11 3h1v1h-1zM4 4h1v1H4zM5 4h1v1H5zM6 4h1v1H6zM7 4h1v1H7zM8 4h1v1H8zM11 4h1v1h-1zM12 4h1v1h-1zM13 4h1v1h-1zM14 4h1v1h-1zM2 5h1v1H2zM3 5h1v1H3zM4 5h1v1H4zM14 5h1v1h-1zM15 5h1v1h-1zM16 5h1v1h-1zM17 5h1v1h-1zM1 6h1v1H1zM2 6h1v1H2zM17 6h1v1h-1zM18 6h1v1h-1zM19 6h1v1h-1zM20 6h1v1h-1zM1 7h1v1H1zM20 7h1v1h-1zM21 7h1v1h-1zM1 8h1v1H1zM2 8h1v1H2zM21 8h1v1h-1zM2 9h1v1H2zM3 9h1v1H3zM4 9h1v1H4zM5 9h1v1H5zM20 9h1v1h-1zM21 9h1v1h-1zM5 10h1v1H5zM6 10h1v1H6zM7 10h1v1H7zM10 10h1v1h-1zM11 10h1v1h-1zM12 10h1v1h-1zM13 10h1v1h-1zM14 10h1v1h-1zM15 10h1v1h-1zM18 10h1v1h-1zM19 10h1v1h-1zM20 10h1v1h-1zM7 11h1v1H7zM8 11h1v1H8zM9 11h1v1H9zM10 11h1v1h-1zM15 11h1v1h-1zM16 11h1v1h-1zM17 11h1v1h-1zM18 11h1v1h-1z"
      />
    </svg>
  )
}

export const CloudSmallLight1 = (props) => {
  return (
    <svg
      aria-hidden="true"
      data-prefix="fas"
      data-icon="cloud-small-light"
      className="prefix__svg-inline--fa prefix__fa-cloud-small-light prefix__fa-w-20"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 16"
      shapeRendering="crispEdges"
      {...props}
    >
      <path
        fill="#839CA9"
        d="M6 3h1v1H6zM7 3h1v1H7zM8 3h1v1H8zM9 3h1v1H9zM3 4h1v1H3zM4 4h1v1H4zM5 4h1v1H5zM6 4h1v1H6zM9 4h1v1H9zM10 4h1v1h-1zM11 4h1v1h-1zM13 4h1v1h-1zM14 4h1v1h-1zM15 4h1v1h-1zM16 4h1v1h-1zM17 4h1v1h-1zM2 5h1v1H2zM3 5h1v1H3zM11 5h1v1h-1zM12 5h1v1h-1zM13 5h1v1h-1zM17 5h1v1h-1zM18 5h1v1h-1zM1 6h1v1H1zM2 6h1v1H2zM18 6h1v1h-1zM19 6h1v1h-1zM20 6h1v1h-1zM1 7h1v1H1zM20 7h1v1h-1zM21 7h1v1h-1zM1 8h1v1H1zM21 8h1v1h-1zM1 9h1v1H1zM2 9h1v1H2zM21 9h1v1h-1zM2 10h1v1H2zM3 10h1v1H3zM4 10h1v1H4zM5 10h1v1H5zM20 10h1v1h-1zM21 10h1v1h-1zM5 11h1v1H5zM6 11h1v1H6zM7 11h1v1H7zM11 11h1v1h-1zM12 11h1v1h-1zM13 11h1v1h-1zM14 11h1v1h-1zM17 11h1v1h-1zM18 11h1v1h-1zM19 11h1v1h-1zM20 11h1v1h-1zM7 12h1v1H7zM8 12h1v1H8zM9 12h1v1H9zM10 12h1v1h-1zM11 12h1v1h-1zM14 12h1v1h-1zM15 12h1v1h-1zM16 12h1v1h-1zM17 12h1v1h-1z"
      />
    </svg>
  )
}

export const CloudSmallLight2 = (props) => {
  return (
    <svg
      aria-hidden="true"
      data-prefix="fas"
      data-icon="cloud-small-light"
      className="prefix__svg-inline--fa prefix__fa-cloud-small-light prefix__fa-w-20"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 16"
      shapeRendering="crispEdges"
      {...props}
    >
      <path
        fill="#839CA9"
        d="M10 3h1v1h-1zM11 3h1v1h-1zM12 3h1v1h-1zM13 3h1v1h-1zM5 4h1v1H5zM6 4h1v1H6zM7 4h1v1H7zM9 4h1v1H9zM10 4h1v1h-1zM13 4h1v1h-1zM14 4h1v1h-1zM16 4h1v1h-1zM17 4h1v1h-1zM18 4h1v1h-1zM19 4h1v1h-1zM3 5h1v1H3zM4 5h1v1H4zM5 5h1v1H5zM7 5h1v1H7zM8 5h1v1H8zM9 5h1v1H9zM14 5h1v1h-1zM15 5h1v1h-1zM16 5h1v1h-1zM19 5h1v1h-1zM20 5h1v1h-1zM2 6h1v1H2zM3 6h1v1H3zM20 6h1v1h-1zM21 6h1v1h-1zM1 7h1v1H1zM2 7h1v1H2zM21 7h1v1h-1zM22 7h1v1h-1zM1 8h1v1H1zM22 8h1v1h-1zM1 9h1v1H1zM22 9h1v1h-1zM1 10h1v1H1zM2 10h1v1H2zM21 10h1v1h-1zM22 10h1v1h-1zM2 11h1v1H2zM3 11h1v1H3zM4 11h1v1H4zM5 11h1v1H5zM7 11h1v1H7zM8 11h1v1H8zM9 11h1v1H9zM13 11h1v1h-1zM14 11h1v1h-1zM15 11h1v1h-1zM16 11h1v1h-1zM19 11h1v1h-1zM20 11h1v1h-1zM21 11h1v1h-1zM5 12h1v1H5zM6 12h1v1H6zM7 12h1v1H7zM9 12h1v1H9zM10 12h1v1h-1zM11 12h1v1h-1zM12 12h1v1h-1zM13 12h1v1h-1zM16 12h1v1h-1zM17 12h1v1h-1zM18 12h1v1h-1zM19 12h1v1h-1z"
      />
    </svg>
  )
}

export const CloudSmallLight3 = (props) => {
  return (
    <svg
      aria-hidden="true"
      data-prefix="fas"
      data-icon="cloud-small-dark"
      className="prefix__svg-inline--fa prefix__fa-cloud-small-dark prefix__fa-w-20"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 16"
      shapeRendering="crispEdges"
      {...props}
    >
      <path
        fill="#839CA9"
        d="M12 3h1v1h-1zM13 3h1v1h-1zM14 3h1v1h-1zM15 3h1v1h-1zM6 4h1v1H6zM7 4h1v1H7zM8 4h1v1H8zM10 4h1v1h-1zM11 4h1v1h-1zM12 4h1v1h-1zM15 4h1v1h-1zM16 4h1v1h-1zM17 4h1v1h-1zM3 5h1v1H3zM4 5h1v1H4zM5 5h1v1H5zM6 5h1v1H6zM8 5h1v1H8zM9 5h1v1H9zM10 5h1v1h-1zM17 5h1v1h-1zM18 5h1v1h-1zM19 5h1v1h-1zM20 5h1v1h-1zM2 6h1v1H2zM3 6h1v1H3zM20 6h1v1h-1zM21 6h1v1h-1zM2 7h1v1H2zM21 7h1v1h-1zM22 7h1v1h-1zM2 8h1v1H2zM3 8h1v1H3zM22 8h1v1h-1zM3 9h1v1H3zM4 9h1v1H4zM8 9h1v1H8zM9 9h1v1H9zM10 9h1v1h-1zM11 9h1v1h-1zM21 9h1v1h-1zM22 9h1v1h-1zM4 10h1v1H4zM5 10h1v1H5zM6 10h1v1H6zM7 10h1v1H7zM8 10h1v1H8zM11 10h1v1h-1zM12 10h1v1h-1zM13 10h1v1h-1zM18 10h1v1h-1zM19 10h1v1h-1zM20 10h1v1h-1zM21 10h1v1h-1zM13 11h1v1h-1zM14 11h1v1h-1zM15 11h1v1h-1zM16 11h1v1h-1zM17 11h1v1h-1zM18 11h1v1h-1z"
      />
    </svg>
  )
}

export const CloudSmallLight4 = (props) => {
  return (
    <svg
      aria-hidden="true"
      data-prefix="fas"
      data-icon="cloud-small-light"
      className="prefix__svg-inline--fa prefix__fa-cloud-small-light prefix__fa-w-20"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 16"
      shapeRendering="crispEdges"
      {...props}
    >
      <path
        fill="#839CA9"
        d="M8 3h1v1H8zM9 3h1v1H9zM10 3h1v1h-1zM11 3h1v1h-1zM4 4h1v1H4zM5 4h1v1H5zM6 4h1v1H6zM7 4h1v1H7zM8 4h1v1H8zM11 4h1v1h-1zM12 4h1v1h-1zM13 4h1v1h-1zM14 4h1v1h-1zM2 5h1v1H2zM3 5h1v1H3zM4 5h1v1H4zM14 5h1v1h-1zM15 5h1v1h-1zM16 5h1v1h-1zM17 5h1v1h-1zM1 6h1v1H1zM2 6h1v1H2zM17 6h1v1h-1zM18 6h1v1h-1zM19 6h1v1h-1zM20 6h1v1h-1zM1 7h1v1H1zM20 7h1v1h-1zM21 7h1v1h-1zM1 8h1v1H1zM2 8h1v1H2zM21 8h1v1h-1zM2 9h1v1H2zM3 9h1v1H3zM4 9h1v1H4zM5 9h1v1H5zM20 9h1v1h-1zM21 9h1v1h-1zM5 10h1v1H5zM6 10h1v1H6zM7 10h1v1H7zM10 10h1v1h-1zM11 10h1v1h-1zM12 10h1v1h-1zM13 10h1v1h-1zM14 10h1v1h-1zM15 10h1v1h-1zM18 10h1v1h-1zM19 10h1v1h-1zM20 10h1v1h-1zM7 11h1v1H7zM8 11h1v1H8zM9 11h1v1H9zM10 11h1v1h-1zM15 11h1v1h-1zM16 11h1v1h-1zM17 11h1v1h-1zM18 11h1v1h-1z"
      />
    </svg>
  )
}

export const CloudMulti1 = (props) => {
  return (
    <svg
      aria-hidden="true"
      data-prefix="fas"
      data-icon="cloud-multi"
      className="prefix__svg-inline--fa prefix__fa-cloud-multi prefix__fa-w-20"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 47 16"
      shapeRendering="crispEdges"
      {...props}
    >
      <path
        fill="#839CA9"
        d="M7 1h1v1H7zM8 1h1v1H8zM9 1h1v1H9zM10 1h1v1h-1zM4 2h1v1H4zM5 2h1v1H5zM6 2h1v1H6zM7 2h1v1H7zM10 2h1v1h-1zM11 2h1v1h-1zM12 2h1v1h-1zM15 2h1v1h-1zM16 2h1v1h-1zM17 2h1v1h-1zM18 2h1v1h-1zM19 2h1v1h-1zM2 3h1v1H2zM3 3h1v1H3zM4 3h1v1H4zM12 3h1v1h-1zM13 3h1v1h-1zM14 3h1v1h-1zM15 3h1v1h-1zM19 3h1v1h-1zM20 3h1v1h-1zM21 3h1v1h-1zM22 3h1v1h-1zM1 4h1v1H1zM2 4h1v1H2zM22 4h1v1h-1zM23 4h1v1h-1zM24 4h1v1h-1zM25 4h1v1h-1z"
      />
      <path fill="#6D838E" d="M26 4h1v1h-1zM27 4h1v1h-1zM28 4h1v1h-1z" />
      <path fill="#839CA9" d="M1 5h1v1H1zM25 5h1v1h-1zM26 5h1v1h-1z" />
      <path
        fill="#6D838E"
        d="M28 5h1v1h-1zM29 5h1v1h-1zM30 5h1v1h-1zM32 5h1v1h-1zM33 5h1v1h-1zM34 5h1v1h-1z"
      />
      <path fill="#839CA9" d="M1 6h1v1H1zM2 6h1v1H2zM26 6h1v1h-1z" />
      <path
        fill="#6D838E"
        d="M30 6h1v1h-1zM31 6h1v1h-1zM32 6h1v1h-1zM34 6h1v1h-1zM35 6h1v1h-1zM36 6h1v1h-1z"
      />
      <path fill="#839CA9" d="M2 7h1v1H2zM3 7h1v1H3zM25 7h1v1h-1zM26 7h1v1h-1z" />
      <path fill="#6D838E" d="M36 7h1v1h-1zM37 7h1v1h-1z" />
      <path
        fill="#839CA9"
        d="M3 8h1v1H3zM4 8h1v1H4zM5 8h1v1H5zM8 8h1v1H8zM9 8h1v1H9zM10 8h1v1h-1zM11 8h1v1h-1zM18 8h1v1h-1zM19 8h1v1h-1zM20 8h1v1h-1zM21 8h1v1h-1zM23 8h1v1h-1zM24 8h1v1h-1zM25 8h1v1h-1z"
      />
      <path fill="#6D838E" d="M37 8h1v1h-1zM38 8h1v1h-1z" />
      <path
        fill="#839CA9"
        d="M5 9h1v1H5zM6 9h1v1H6zM7 9h1v1H7zM8 9h1v1H8zM11 9h1v1h-1zM12 9h1v1h-1zM15 9h1v1h-1zM16 9h1v1h-1zM17 9h1v1h-1zM18 9h1v1h-1zM21 9h1v1h-1zM22 9h1v1h-1zM23 9h1v1h-1z"
      />
      <path fill="#6D838E" d="M38 9h1v1h-1z" />
      <path
        fill="#839CA9"
        d="M12 10h1v1h-1zM13 10h1v1h-1zM14 10h1v1h-1zM15 10h1v1h-1z"
      />
      <path
        fill="#6D838E"
        d="M37 10h1v1h-1zM38 10h1v1h-1zM13 11h1v1h-1zM14 11h1v1h-1zM30 11h1v1h-1zM31 11h1v1h-1zM32 11h1v1h-1zM33 11h1v1h-1zM36 11h1v1h-1zM37 11h1v1h-1zM14 12h1v1h-1zM15 12h1v1h-1zM16 12h1v1h-1zM19 12h1v1h-1zM20 12h1v1h-1zM21 12h1v1h-1zM22 12h1v1h-1zM28 12h1v1h-1zM29 12h1v1h-1zM30 12h1v1h-1zM33 12h1v1h-1zM34 12h1v1h-1zM35 12h1v1h-1zM36 12h1v1h-1zM16 13h1v1h-1zM17 13h1v1h-1zM18 13h1v1h-1zM19 13h1v1h-1zM22 13h1v1h-1zM23 13h1v1h-1zM26 13h1v1h-1zM27 13h1v1h-1zM28 13h1v1h-1zM23 14h1v1h-1zM24 14h1v1h-1zM25 14h1v1h-1zM26 14h1v1h-1z"
      />
    </svg>
  )
}

export const CloudMulti2 = (props) => {
  return (
    <svg
      aria-hidden="true"
      data-prefix="fas"
      data-icon="cloud-multi"
      className="prefix__svg-inline--fa prefix__fa-cloud-multi prefix__fa-w-20"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 47 16"
      shapeRendering="crispEdges"
      {...props}
    >
      <path
        fill="#839CA9"
        d="M22 0h1v1h-1zM23 0h1v1h-1zM24 0h1v1h-1zM25 0h1v1h-1zM27 0h1v1h-1zM28 0h1v1h-1zM29 0h1v1h-1zM15 1h1v1h-1zM16 1h1v1h-1zM17 1h1v1h-1zM18 1h1v1h-1zM20 1h1v1h-1zM21 1h1v1h-1zM22 1h1v1h-1zM25 1h1v1h-1zM26 1h1v1h-1zM27 1h1v1h-1zM29 1h1v1h-1zM30 1h1v1h-1zM32 1h1v1h-1zM33 1h1v1h-1zM34 1h1v1h-1zM13 2h1v1h-1zM14 2h1v1h-1zM15 2h1v1h-1zM18 2h1v1h-1zM19 2h1v1h-1zM20 2h1v1h-1zM30 2h1v1h-1zM31 2h1v1h-1zM32 2h1v1h-1zM34 2h1v1h-1zM35 2h1v1h-1zM36 2h1v1h-1zM12 3h1v1h-1zM13 3h1v1h-1zM36 3h1v1h-1zM37 3h1v1h-1zM11 4h1v1h-1zM12 4h1v1h-1zM37 4h1v1h-1zM38 4h1v1h-1z"
      />
      <path fill="#6D838E" d="M7 5h1v1H7zM8 5h1v1H8zM9 5h1v1H9zM10 5h1v1h-1z" />
      <path fill="#839CA9" d="M11 5h1v1h-1zM38 5h1v1h-1z" />
      <path
        fill="#6D838E"
        d="M4 6h1v1H4zM5 6h1v1H5zM6 6h1v1H6zM7 6h1v1H7zM10 6h1v1h-1z"
      />
      <path
        fill="#839CA9"
        d="M11 6h1v1h-1zM12 6h1v1h-1zM37 6h1v1h-1zM38 6h1v1h-1z"
      />
      <path fill="#6D838E" d="M2 7h1v1H2zM3 7h1v1H3zM4 7h1v1H4z" />
      <path
        fill="#839CA9"
        d="M12 7h1v1h-1zM13 7h1v1h-1zM14 7h1v1h-1zM36 7h1v1h-1zM37 7h1v1h-1z"
      />
      <path fill="#6D838E" d="M1 8h1v1H1zM2 8h1v1H2z" />
      <path
        fill="#839CA9"
        d="M14 8h1v1h-1zM15 8h1v1h-1zM16 8h1v1h-1zM18 8h1v1h-1zM19 8h1v1h-1zM20 8h1v1h-1zM24 8h1v1h-1zM25 8h1v1h-1zM26 8h1v1h-1zM28 8h1v1h-1zM29 8h1v1h-1zM30 8h1v1h-1zM31 8h1v1h-1zM34 8h1v1h-1zM35 8h1v1h-1zM36 8h1v1h-1z"
      />
      <path fill="#6D838E" d="M1 9h1v1H1z" />
      <path
        fill="#839CA9"
        d="M16 9h1v1h-1zM17 9h1v1h-1zM18 9h1v1h-1zM20 9h1v1h-1zM21 9h1v1h-1zM22 9h1v1h-1zM23 9h1v1h-1zM24 9h1v1h-1zM26 9h1v1h-1zM27 9h1v1h-1zM28 9h1v1h-1zM31 9h1v1h-1zM32 9h1v1h-1zM33 9h1v1h-1zM34 9h1v1h-1z"
      />
      <path
        fill="#6D838E"
        d="M1 10h1v1H1zM2 10h1v1H2zM26 10h1v1h-1zM2 11h1v1H2zM3 11h1v1H3zM25 11h1v1h-1zM26 11h1v1h-1zM3 12h1v1H3zM4 12h1v1H4zM5 12h1v1H5zM8 12h1v1H8zM9 12h1v1H9zM10 12h1v1h-1zM11 12h1v1h-1zM18 12h1v1h-1zM19 12h1v1h-1zM20 12h1v1h-1zM21 12h1v1h-1zM23 12h1v1h-1zM24 12h1v1h-1zM25 12h1v1h-1zM5 13h1v1H5zM6 13h1v1H6zM7 13h1v1H7zM8 13h1v1H8zM11 13h1v1h-1zM12 13h1v1h-1zM15 13h1v1h-1zM16 13h1v1h-1zM17 13h1v1h-1zM18 13h1v1h-1zM21 13h1v1h-1zM22 13h1v1h-1zM23 13h1v1h-1zM12 14h1v1h-1zM13 14h1v1h-1zM14 14h1v1h-1zM15 14h1v1h-1z"
      />
    </svg>
  )
}

export const CloudMulti3 = (props) => {
  return (
    <svg
      aria-hidden="true"
      data-prefix="fas"
      data-icon="cloud-multi"
      className="prefix__svg-inline--fa prefix__fa-cloud-multi prefix__fa-w-20"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 47 16"
      shapeRendering="crispEdges"
      {...props}
    >
      <path
        fill="#839CA9"
        d="M30 1h1v1h-1zM31 1h1v1h-1zM32 1h1v1h-1zM33 1h1v1h-1zM28 2h1v1h-1zM29 2h1v1h-1zM30 2h1v1h-1zM33 2h1v1h-1zM34 2h1v1h-1zM35 2h1v1h-1zM36 2h1v1h-1zM38 2h1v1h-1zM39 2h1v1h-1zM40 2h1v1h-1zM22 3h1v1h-1zM23 3h1v1h-1zM24 3h1v1h-1zM26 3h1v1h-1zM27 3h1v1h-1zM28 3h1v1h-1zM36 3h1v1h-1zM37 3h1v1h-1zM38 3h1v1h-1zM40 3h1v1h-1zM41 3h1v1h-1zM42 3h1v1h-1zM20 4h1v1h-1zM21 4h1v1h-1zM22 4h1v1h-1zM24 4h1v1h-1zM25 4h1v1h-1zM26 4h1v1h-1zM42 4h1v1h-1zM43 4h1v1h-1z"
      />
      <path
        fill="#6D838E"
        d="M9 5h1v1H9zM10 5h1v1h-1zM11 5h1v1h-1zM12 5h1v1h-1z"
      />
      <path
        fill="#839CA9"
        d="M18 5h1v1h-1zM19 5h1v1h-1zM20 5h1v1h-1zM43 5h1v1h-1zM44 5h1v1h-1z"
      />
      <path
        fill="#6D838E"
        d="M7 6h1v1H7zM8 6h1v1H8zM9 6h1v1H9zM12 6h1v1h-1zM13 6h1v1h-1zM14 6h1v1h-1zM16 6h1v1h-1z"
      />
      <path fill="#839CA9" d="M17 6h1v1h-1zM18 6h1v1h-1zM44 6h1v1h-1z" />
      <path
        fill="#6D838E"
        d="M4 7h1v1H4zM5 7h1v1H5zM6 7h1v1H6zM7 7h1v1H7zM14 7h1v1h-1zM15 7h1v1h-1zM16 7h1v1h-1z"
      />
      <path fill="#839CA9" d="M17 7h1v1h-1zM43 7h1v1h-1zM44 7h1v1h-1z" />
      <path fill="#6D838E" d="M3 8h1v1H3zM4 8h1v1H4z" />
      <path
        fill="#839CA9"
        d="M17 8h1v1h-1zM18 8h1v1h-1zM36 8h1v1h-1zM37 8h1v1h-1zM38 8h1v1h-1zM39 8h1v1h-1zM42 8h1v1h-1zM43 8h1v1h-1z"
      />
      <path fill="#6D838E" d="M2 9h1v1H2zM3 9h1v1H3z" />
      <path
        fill="#839CA9"
        d="M18 9h1v1h-1zM19 9h1v1h-1zM20 9h1v1h-1zM21 9h1v1h-1zM24 9h1v1h-1zM25 9h1v1h-1zM26 9h1v1h-1zM27 9h1v1h-1zM33 9h1v1h-1zM34 9h1v1h-1zM35 9h1v1h-1zM36 9h1v1h-1zM39 9h1v1h-1zM40 9h1v1h-1zM41 9h1v1h-1zM42 9h1v1h-1z"
      />
      <path fill="#6D838E" d="M2 10h1v1H2z" />
      <path
        fill="#839CA9"
        d="M21 10h1v1h-1zM22 10h1v1h-1zM23 10h1v1h-1zM24 10h1v1h-1zM27 10h1v1h-1zM28 10h1v1h-1zM31 10h1v1h-1zM32 10h1v1h-1zM33 10h1v1h-1z"
      />
      <path fill="#6D838E" d="M2 11h1v1H2zM3 11h1v1H3z" />
      <path
        fill="#839CA9"
        d="M28 11h1v1h-1zM29 11h1v1h-1zM30 11h1v1h-1zM31 11h1v1h-1z"
      />
      <path
        fill="#6D838E"
        d="M3 12h1v1H3zM4 12h1v1H4zM5 12h1v1H5zM6 12h1v1H6zM28 12h1v1h-1zM29 12h1v1h-1zM6 13h1v1H6zM7 13h1v1H7zM8 13h1v1H8zM13 13h1v1h-1zM14 13h1v1h-1zM15 13h1v1h-1zM16 13h1v1h-1zM20 13h1v1h-1zM21 13h1v1h-1zM22 13h1v1h-1zM23 13h1v1h-1zM25 13h1v1h-1zM26 13h1v1h-1zM27 13h1v1h-1zM28 13h1v1h-1zM8 14h1v1H8zM9 14h1v1H9zM10 14h1v1h-1zM11 14h1v1h-1zM12 14h1v1h-1zM13 14h1v1h-1zM16 14h1v1h-1zM17 14h1v1h-1zM18 14h1v1h-1zM19 14h1v1h-1zM20 14h1v1h-1zM23 14h1v1h-1zM24 14h1v1h-1zM25 14h1v1h-1z"
      />
    </svg>
  )
}

export const CloudMulti4 = (props) => {
  return (
    <svg
      aria-hidden="true"
      data-prefix="fas"
      data-icon="cloud-multi"
      className="prefix__svg-inline--fa prefix__fa-cloud-multi prefix__fa-w-20"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 47 16"
      shapeRendering="crispEdges"
      {...props}
    >
      <path
        fill="#839CA9"
        d="M10 1h1v1h-1zM11 1h1v1h-1zM12 1h1v1h-1zM13 1h1v1h-1zM8 2h1v1H8zM9 2h1v1H9zM10 2h1v1h-1zM13 2h1v1h-1zM14 2h1v1h-1zM15 2h1v1h-1zM18 2h1v1h-1zM19 2h1v1h-1zM20 2h1v1h-1zM5 3h1v1H5zM6 3h1v1H6zM7 3h1v1H7zM8 3h1v1H8zM15 3h1v1h-1zM16 3h1v1h-1zM17 3h1v1h-1zM18 3h1v1h-1zM20 3h1v1h-1zM21 3h1v1h-1zM22 3h1v1h-1zM23 3h1v1h-1zM25 3h1v1h-1zM26 3h1v1h-1zM27 3h1v1h-1zM4 4h1v1H4zM5 4h1v1H5zM23 4h1v1h-1zM24 4h1v1h-1zM25 4h1v1h-1zM27 4h1v1h-1zM28 4h1v1h-1zM3 5h1v1H3zM4 5h1v1H4zM28 5h1v1h-1zM29 5h1v1h-1zM30 5h1v1h-1z"
      />
      <path
        fill="#6D838E"
        d="M32 5h1v1h-1zM33 5h1v1h-1zM34 5h1v1h-1zM35 5h1v1h-1zM36 5h1v1h-1z"
      />
      <path fill="#839CA9" d="M3 6h1v1H3zM30 6h1v1h-1zM31 6h1v1h-1z" />
      <path
        fill="#6D838E"
        d="M32 6h1v1h-1zM36 6h1v1h-1zM37 6h1v1h-1zM38 6h1v1h-1zM40 6h1v1h-1zM41 6h1v1h-1zM42 6h1v1h-1z"
      />
      <path fill="#839CA9" d="M3 7h1v1H3zM31 7h1v1h-1z" />
      <path
        fill="#6D838E"
        d="M38 7h1v1h-1zM39 7h1v1h-1zM40 7h1v1h-1zM42 7h1v1h-1zM43 7h1v1h-1zM44 7h1v1h-1z"
      />
      <path fill="#839CA9" d="M3 8h1v1H3zM4 8h1v1H4zM31 8h1v1h-1z" />
      <path fill="#6D838E" d="M44 8h1v1h-1zM45 8h1v1h-1z" />
      <path
        fill="#839CA9"
        d="M4 9h1v1H4zM5 9h1v1H5zM6 9h1v1H6zM7 9h1v1H7zM30 9h1v1h-1zM31 9h1v1h-1z"
      />
      <path fill="#6D838E" d="M45 9h1v1h-1zM46 9h1v1h-1z" />
      <path
        fill="#839CA9"
        d="M7 10h1v1H7zM8 10h1v1H8zM9 10h1v1H9zM14 10h1v1h-1zM15 10h1v1h-1zM16 10h1v1h-1zM17 10h1v1h-1zM22 10h1v1h-1zM23 10h1v1h-1zM24 10h1v1h-1zM25 10h1v1h-1zM27 10h1v1h-1zM28 10h1v1h-1zM29 10h1v1h-1zM30 10h1v1h-1z"
      />
      <path fill="#6D838E" d="M46 10h1v1h-1z" />
      <path
        fill="#839CA9"
        d="M9 11h1v1H9zM10 11h1v1h-1zM11 11h1v1h-1zM12 11h1v1h-1zM13 11h1v1h-1zM14 11h1v1h-1zM17 11h1v1h-1zM18 11h1v1h-1zM19 11h1v1h-1zM20 11h1v1h-1zM21 11h1v1h-1zM22 11h1v1h-1zM25 11h1v1h-1zM26 11h1v1h-1zM27 11h1v1h-1z"
      />
      <path
        fill="#6D838E"
        d="M45 11h1v1h-1zM46 11h1v1h-1zM19 12h1v1h-1zM20 12h1v1h-1zM44 12h1v1h-1zM45 12h1v1h-1zM20 13h1v1h-1zM21 13h1v1h-1zM23 13h1v1h-1zM24 13h1v1h-1zM25 13h1v1h-1zM29 13h1v1h-1zM30 13h1v1h-1zM31 13h1v1h-1zM32 13h1v1h-1zM33 13h1v1h-1zM36 13h1v1h-1zM37 13h1v1h-1zM38 13h1v1h-1zM39 13h1v1h-1zM42 13h1v1h-1zM43 13h1v1h-1zM44 13h1v1h-1zM21 14h1v1h-1zM22 14h1v1h-1zM23 14h1v1h-1zM25 14h1v1h-1zM26 14h1v1h-1zM27 14h1v1h-1zM28 14h1v1h-1zM29 14h1v1h-1zM33 14h1v1h-1zM34 14h1v1h-1zM35 14h1v1h-1zM36 14h1v1h-1zM39 14h1v1h-1zM40 14h1v1h-1zM41 14h1v1h-1zM42 14h1v1h-1z"
      />
    </svg>
  )
}

export const Character1 = (props) => {
  return (
    <svg
      aria-hidden="true"
      data-prefix="fas"
      data-icon="character"
      className="prefix__svg-inline--fa prefix__fa-character prefix__fa-w-20"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="-5 -5 16 16"
      shapeRendering="crispEdges"
      {...props}
    >
      <path fill="#7E6C5F" d="M1 2h1v1H1zM2 2h1v1H2z" />
      <path fill="#937B6A" d="M3 2h1v1H3zM4 2h1v1H4z" />
      <path fill="#7E6C5F" d="M1 3h1v1H1z" />
      <path fill="#D68667" d="M2 3h1v1H2z" />
      <path fill="#F3EFE7" d="M3 3h1v1H3z" />
      <path fill="#EB9470" d="M4 3h1v1H4z" />
      <path fill="#F3EFE7" d="M5 3h1v1H5z" />
      <path fill="#D68667" d="M1 4h1v1H1zM2 4h1v1H2z" />
      <path fill="#EB9470" d="M3 4h1v1H3zM4 4h1v1H4z" />
      <path fill="#AA9F83" d="M5 4h1v1H5z" />
      <path fill="#D68667" d="M1 5h1v1H1zM2 5h1v1H2z" />
      <path fill="#EB9470" d="M3 5h1v1H3zM4 5h1v1H4z" />
      <path fill="#CC5C5C" d="M1 6h1v1H1zM2 6h1v1H2z" />
      <path fill="#E77373" d="M3 6h1v1H3zM4 6h1v1H4z" />
      <path fill="#AA9F83" d="M1 7h1v1H1zM2 7h1v1H2zM3 7h1v1H3zM4 7h1v1H4z" />
    </svg>
  )
}

export const Character2 = (props) => {
  return (
    <svg
      aria-hidden="true"
      data-prefix="fas"
      data-icon="character"
      className="prefix__svg-inline--fa prefix__fa-character prefix__fa-w-20"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="-5 -5 16 16"
      shapeRendering="crispEdges"
      {...props}
    >
      <path fill="#7E6C5F" d="M1 2h1v1H1zM2 2h1v1H2z" />
      <path fill="#937B6A" d="M3 2h1v1H3zM4 2h1v1H4z" />
      <path fill="#7E6C5F" d="M1 3h1v1H1z" />
      <path fill="#D68667" d="M2 3h1v1H2z" />
      <path fill="#F3EFE7" d="M3 3h1v1H3z" />
      <path fill="#EB9470" d="M4 3h1v1H4z" />
      <path fill="#F3EFE7" d="M5 3h1v1H5z" />
      <path fill="#D68667" d="M1 4h1v1H1zM2 4h1v1H2z" />
      <path fill="#EB9470" d="M3 4h1v1H3zM4 4h1v1H4z" />
      <path fill="#C3B797" d="M5 4h1v1H5z" />
      <path fill="#D68667" d="M1 5h1v1H1zM2 5h1v1H2z" />
      <path fill="#EB9470" d="M3 5h1v1H3zM4 5h1v1H4z" />
      <path fill="#CC5C5C" d="M1 6h1v1H1zM2 6h1v1H2z" />
      <path fill="#E77373" d="M3 6h1v1H3zM4 6h1v1H4z" />
      <path fill="#C3B797" d="M1 7h1v1H1zM2 7h1v1H2zM3 7h1v1H3zM4 7h1v1H4z" />
    </svg>
  )
}

export const Key1 = (props) => {
  return (
    <svg
      aria-hidden="true"
      data-prefix="fas"
      data-icon="key"
      className="prefix__svg-inline--fa prefix__fa-key prefix__fa-w-20"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="-2 -2 16 16"
      shapeRendering="crispEdges"
      {...props}
    >
      <path fill="#EFE30C" d="M1 4h1v1H1zM2 4h1v1H2zM3 4h1v1H3zM1 5h1v1H1z" />
      <path fill="#AA9F83" d="M2 5h1v1H2z" />
      <path
        fill="#EFE30C"
        d="M3 5h1v1H3zM4 5h1v1H4zM5 5h1v1H5zM6 5h1v1H6zM7 5h1v1H7zM1 6h1v1H1zM2 6h1v1H2zM3 6h1v1H3z"
      />
      <path fill="#AA9F83" d="M4 6h1v1H4z" />
      <path fill="#EFE30C" d="M5 6h1v1H5z" />
      <path fill="#AA9F83" d="M6 6h1v1H6z" />
      <path fill="#EFE30C" d="M7 6h1v1H7z" />
      <path
        fill="#AA9F83"
        d="M1 7h1v1H1zM2 7h1v1H2zM3 7h1v1H3zM5 7h1v1H5zM7 7h1v1H7z"
      />
    </svg>
  )
}

export const Key2 = (props) => {
  return (
    <svg
      aria-hidden="true"
      data-prefix="fas"
      data-icon="key"
      className="prefix__svg-inline--fa prefix__fa-key prefix__fa-w-20"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="-2 -2 16 16"
      shapeRendering="crispEdges"
      {...props}
    >
      <path fill="#EFE30C" d="M1 4h1v1H1zM2 4h1v1H2zM3 4h1v1H3zM1 5h1v1H1z" />
      <path fill="#C3B797" d="M2 5h1v1H2z" />
      <path
        fill="#EFE30C"
        d="M3 5h1v1H3zM4 5h1v1H4zM5 5h1v1H5zM6 5h1v1H6zM7 5h1v1H7zM1 6h1v1H1zM2 6h1v1H2zM3 6h1v1H3z"
      />
      <path fill="#C3B797" d="M4 6h1v1H4z" />
      <path fill="#EFE30C" d="M5 6h1v1H5z" />
      <path fill="#C3B797" d="M6 6h1v1H6z" />
      <path fill="#EFE30C" d="M7 6h1v1H7z" />
      <path
        fill="#C3B797"
          d="M1 7h1v1H1zM2 7h1v1H2zM3 7h1v1H3zM5 7h1v1H5zM7 7h1v1H7z"
        />
    </svg>
  )
}

export const Ghost1 = (props) => {
  return (
    <svg
      aria-hidden="true"
      data-prefix="fas"
      data-icon="ghost"
      className="prefix__svg-inline--fa prefix__fa-ghost prefix__fa-w-20"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 16 16"
      shapeRendering="crispEdges"
      {...props}
    >
      <path fill="#F3EFE7" d="M2 2h1v1H2zM3 2h1v1H3zM4 2h1v1H4z" />
      <path fill="#EEE1C4" d="M1 3h1v1H1z" />
      <path fill="#F3EFE7" d="M2 3h1v1H2zM3 3h1v1H3zM4 3h1v1H4zM5 3h1v1H5z" />
      <path fill="#EEE1C4" d="M1 4h1v1H1z" />
      <path fill="#F3EFE7" d="M2 4h1v1H2z" />
      <path fill="#7E6C5F" d="M3 4h1v1H3z" />
      <path fill="#F3EFE7" d="M4 4h1v1H4z" />
      <path fill="#7E6C5F" d="M5 4h1v1H5z" />
      <path fill="#EEE1C4" d="M1 5h1v1H1z" />
      <path fill="#F3EFE7" d="M2 5h1v1H2zM3 5h1v1H3zM4 5h1v1H4zM5 5h1v1H5z" />
      <path fill="#AA9F83" d="M1 6h1v1H1z" />
      <path fill="#EEE1C4" d="M2 6h1v1H2z" />
      <path fill="#F3EFE7" d="M3 6h1v1H3z" />
      <path fill="#AA9F83" d="M4 6h1v1H4z" />
      <path fill="#F3EFE7" d="M5 6h1v1H5z" />
      <path fill="#AA9F83" d="M2 7h1v1H2zM3 7h1v1H3zM5 7h1v1H5z" />
    </svg>
    )
}

export const Ghost2 = (props) => {
  return (
    <svg
      aria-hidden="true"
      data-prefix="fas"
      data-icon="ghost"
      className="prefix__svg-inline--fa prefix__fa-ghost prefix__fa-w-20"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 16 16"
      shapeRendering="crispEdges"
      {...props}
    >
      <path fill="#F3EFE7" d="M2 2h1v1H2zM3 2h1v1H3zM4 2h1v1H4z" />
      <path fill="#EEE1C4" d="M1 3h1v1H1z" />
      <path fill="#F3EFE7" d="M2 3h1v1H2zM3 3h1v1H3zM4 3h1v1H4zM5 3h1v1H5z" />
      <path fill="#EEE1C4" d="M1 4h1v1H1z" />
      <path fill="#F3EFE7" d="M2 4h1v1H2z" />
      <path fill="#7E6C5F" d="M3 4h1v1H3z" />
      <path fill="#F3EFE7" d="M4 4h1v1H4z" />
      <path fill="#7E6C5F" d="M5 4h1v1H5z" />
      <path fill="#EEE1C4" d="M1 5h1v1H1z" />
      <path fill="#F3EFE7" d="M2 5h1v1H2zM3 5h1v1H3zM4 5h1v1H4zM5 5h1v1H5z" />
      <path fill="#C3B797" d="M1 6h1v1H1z" />
      <path fill="#EEE1C4" d="M2 6h1v1H2z" />
      <path fill="#F3EFE7" d="M3 6h1v1H3z" />
      <path fill="#C3B797" d="M4 6h1v1H4z" />
      <path fill="#F3EFE7" d="M5 6h1v1H5z" />
      <path fill="#C3B797" d="M2 7h1v1H2zM3 7h1v1H3zM5 7h1v1H5z" />
    </svg>
    )
}

export const ButtonRed1 = (props) => {
  return (
    <svg
      aria-hidden="true"
      data-prefix="fas"
      data-icon="button"
      className="prefix__svg-inline--fa prefix__fa-button prefix__fa-w-20"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 8 8"
      shapeRendering="crispEdges"
      {...props}
    >
    <path fill="#EB9470" d="M2 1h1v1H2zM3 1h1v1H3zM4 1h1v1H4zM1 2h1v1H1z" />
    <path fill="#EEE1C4" d="M2 2h1v1H2zM3 2h1v1H3zM4 2h1v1H4z" />
    <path fill="#EB9470" d="M5 2h1v1H5zM1 3h1v1H1z" />
    <path fill="#EEE1C4" d="M2 3h1v1H2z" />
    <path fill="#EB9470" d="M3 3h1v1H3z" />
    <path fill="#EEE1C4" d="M4 3h1v1H4z" />
    <path fill="#EB9470" d="M5 3h1v1H5zM1 4h1v1H1z" />
    <path fill="#EEE1C4" d="M2 4h1v1H2z" />
    <path fill="#EB9470" d="M3 4h1v1H3z" />
    <path fill="#EEE1C4" d="M4 4h1v1H4z" />
    <path fill="#EB9470" d="M5 4h1v1H5zM1 5h1v1H1z" />
    <path fill="#EEE1C4" d="M2 5h1v1H2zM3 5h1v1H3zM4 5h1v1H4z" />
    <path fill="#EB9470" d="M5 5h1v1H5z" />
    <path fill="#AA9F83" d="M1 6h1v1H1z" />
    <path fill="#EB9470" d="M2 6h1v1H2zM3 6h1v1H3zM4 6h1v1H4z" />
    <path fill="#AA9F83" d="M5 6h1v1H5zM2 7h1v1H2zM3 7h1v1H3zM4 7h1v1H4z" />
  </svg>
    )
}

export const ButtonRed2 = (props) => {
  return (
    <svg
      aria-hidden="true"
      data-prefix="fas"
      data-icon="button"
      className="prefix__svg-inline--fa prefix__fa-button prefix__fa-w-20"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 8 8"
      shapeRendering="crispEdges"
      {...props}
    >
      <path fill="#EB9470" d="M2 1h1v1H2zM3 1h1v1H3zM4 1h1v1H4zM1 2h1v1H1z" />
      <path fill="#EEE1C4" d="M2 2h1v1H2zM3 2h1v1H3zM4 2h1v1H4z" />
      <path fill="#EB9470" d="M5 2h1v1H5zM1 3h1v1H1z" />
      <path fill="#EEE1C4" d="M2 3h1v1H2z" />
      <path fill="#EB9470" d="M3 3h1v1H3z" />
      <path fill="#EEE1C4" d="M4 3h1v1H4z" />
      <path fill="#EB9470" d="M5 3h1v1H5zM1 4h1v1H1z" />
      <path fill="#EEE1C4" d="M2 4h1v1H2z" />
      <path fill="#EB9470" d="M3 4h1v1H3z" />
      <path fill="#EEE1C4" d="M4 4h1v1H4z" />
      <path fill="#EB9470" d="M5 4h1v1H5zM1 5h1v1H1z" />
      <path fill="#EEE1C4" d="M2 5h1v1H2zM3 5h1v1H3zM4 5h1v1H4z" />
      <path fill="#EB9470" d="M5 5h1v1H5z" />
      <path fill="#C3B797" d="M1 6h1v1H1z" />
      <path fill="#EB9470" d="M2 6h1v1H2zM3 6h1v1H3zM4 6h1v1H4z" />
      <path fill="#C3B797" d="M5 6h1v1H5zM2 7h1v1H2zM3 7h1v1H3zM4 7h1v1H4z" />
    </svg>
  )
}

export const ButtonBlue1 = (props) => {
  return (
    <svg
      aria-hidden="true"
      data-prefix="fas"
      data-icon="button"
      className="prefix__svg-inline--fa prefix__fa-button prefix__fa-w-20"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 8 8"
      shapeRendering="crispEdges"
      {...props}
    >
      <path
        fill="#8098DF"
        d="M2 1h1v1H2zM3 1h1v1H3zM4 1h1v1H4zM5 1h1v1H5zM1 2h1v1H1z"
      />
      <path fill="#EEE1C4" d="M2 2h1v1H2zM3 2h1v1H3zM4 2h1v1H4zM5 2h1v1H5z" />
      <path fill="#8098DF" d="M6 2h1v1H6zM1 3h1v1H1z" />
      <path fill="#EEE1C4" d="M2 3h1v1H2z" />
      <path fill="#8098DF" d="M3 3h1v1H3z" />
      <path fill="#EEE1C4" d="M4 3h1v1H4zM5 3h1v1H5z" />
      <path fill="#8098DF" d="M6 3h1v1H6zM1 4h1v1H1z" />
      <path fill="#EEE1C4" d="M2 4h1v1H2zM3 4h1v1H3z" />
      <path fill="#8098DF" d="M4 4h1v1H4z" />
      <path fill="#EEE1C4" d="M5 4h1v1H5z" />
      <path fill="#8098DF" d="M6 4h1v1H6zM1 5h1v1H1z" />
      <path fill="#EEE1C4" d="M2 5h1v1H2zM3 5h1v1H3zM4 5h1v1H4zM5 5h1v1H5z" />
      <path fill="#8098DF" d="M6 5h1v1H6z" />
      <path fill="#AA9F83" d="M1 6h1v1H1z" />
      <path fill="#8098DF" d="M2 6h1v1H2zM3 6h1v1H3zM4 6h1v1H4zM5 6h1v1H5z" />
      <path
        fill="#AA9F83"
        d="M6 6h1v1H6zM2 7h1v1H2zM3 7h1v1H3zM4 7h1v1H4zM5 7h1v1H5z"
      />
    </svg>
  )
}


export const ButtonBlue2 = (props) => {
  return (
    <svg
      aria-hidden="true"
      data-prefix="fas"
      data-icon="button"
      className="prefix__svg-inline--fa prefix__fa-button prefix__fa-w-20"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 8 8"
      shapeRendering="crispEdges"
      {...props}
    >
      <path
        fill="#8098DF"
        d="M2 1h1v1H2zM3 1h1v1H3zM4 1h1v1H4zM5 1h1v1H5zM1 2h1v1H1z"
      />
      <path fill="#EEE1C4" d="M2 2h1v1H2zM3 2h1v1H3zM4 2h1v1H4zM5 2h1v1H5z" />
      <path fill="#8098DF" d="M6 2h1v1H6zM1 3h1v1H1z" />
      <path fill="#EEE1C4" d="M2 3h1v1H2z" />
      <path fill="#8098DF" d="M3 3h1v1H3z" />
      <path fill="#EEE1C4" d="M4 3h1v1H4zM5 3h1v1H5z" />
      <path fill="#8098DF" d="M6 3h1v1H6zM1 4h1v1H1z" />
      <path fill="#EEE1C4" d="M2 4h1v1H2zM3 4h1v1H3z" />
      <path fill="#8098DF" d="M4 4h1v1H4z" />
      <path fill="#EEE1C4" d="M5 4h1v1H5z" />
      <path fill="#8098DF" d="M6 4h1v1H6zM1 5h1v1H1z" />
      <path fill="#EEE1C4" d="M2 5h1v1H2zM3 5h1v1H3zM4 5h1v1H4zM5 5h1v1H5z" />
      <path fill="#8098DF" d="M6 5h1v1H6z" />
      <path fill="#C3B797" d="M1 6h1v1H1z" />
      <path fill="#8098DF" d="M2 6h1v1H2zM3 6h1v1H3zM4 6h1v1H4zM5 6h1v1H5z" />
      <path
        fill="#C3B797"
        d="M6 6h1v1H6zM2 7h1v1H2zM3 7h1v1H3zM4 7h1v1H4zM5 7h1v1H5z"
      />
    </svg>
  )
}

export const FlowerPurple1 = (props) => {
  return (
    <svg
      aria-hidden="true"
      data-prefix="fas"
      data-icon="flower"
      className="prefix__svg-inline--fa prefix__fa-flower prefix__fa-w-20"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 8 8"
      shapeRendering="crispEdges"
      {...props}
    >
      <path fill="#6F8B6E" d="M3 1h1v1H3zM4 1h1v1H4z" />
      <path fill="#B089AB" d="M2 2h1v1H2z" />
      <path fill="#6F8B6E" d="M5 2h1v1H5zM10 2h1v1h-1zM11 2h1v1h-1z" />
      <path fill="#B089AB" d="M1 3h1v1H1z" />
      <path fill="#8E6D89" d="M2 3h1v1H2z" />
      <path fill="#B089AB" d="M3 3h1v1H3z" />
      <path fill="#6F8B6E" d="M5 3h1v1H5zM9 3h1v1H9zM12 3h1v1h-1z" />
      <path fill="#B089AB" d="M13 3h1v1h-1zM2 4h1v1H2z" />
      <path fill="#6F8B6E" d="M5 4h1v1H5zM9 4h1v1H9z" />
      <path fill="#B089AB" d="M12 4h1v1h-1z" />
      <path fill="#8E6D89" d="M13 4h1v1h-1z" />
      <path fill="#B089AB" d="M14 4h1v1h-1z" />
      <path fill="#6F8B6E" d="M5 5h1v1H5zM9 5h1v1H9z" />
      <path fill="#B089AB" d="M13 5h1v1h-1z" />
      <path
        fill="#6F8B6E"
        d="M5 6h1v1H5zM9 6h1v1H9zM5 7h1v1H5zM9 7h1v1H9zM3 9h1v1H3zM4 9h1v1H4z"
      />
      <path fill="#839CA9" d="M2 10h1v1H2z" />
      <path fill="#6F8B6E" d="M5 10h1v1H5zM10 10h1v1h-1zM11 10h1v1h-1z" />
      <path fill="#839CA9" d="M1 11h1v1H1z" />
      <path fill="#6D838E" d="M2 11h1v1H2z" />
      <path fill="#839CA9" d="M3 11h1v1H3z" />
      <path fill="#6F8B6E" d="M5 11h1v1H5zM9 11h1v1H9zM12 11h1v1h-1z" />
      <path fill="#839CA9" d="M13 11h1v1h-1zM2 12h1v1H2z" />
      <path fill="#6F8B6E" d="M5 12h1v1H5zM9 12h1v1H9z" />
      <path fill="#839CA9" d="M12 12h1v1h-1z" />
      <path fill="#6D838E" d="M13 12h1v1h-1z" />
      <path fill="#839CA9" d="M14 12h1v1h-1z" />
      <path fill="#6F8B6E" d="M5 13h1v1H5zM9 13h1v1H9z" />
      <path fill="#839CA9" d="M13 13h1v1h-1z" />
      <path fill="#6F8B6E" d="M5 14h1v1H5zM9 14h1v1H9zM5 15h1v1H5zM9 15h1v1H9z" />
    </svg>
  )
}

export const FlowerPurple2 = (props) => {
  return (
    <svg
      aria-hidden="true"
      data-prefix="fas"
      data-icon="flower"
      className="prefix__svg-inline--fa prefix__fa-flower prefix__fa-w-20"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 8 8"
      shapeRendering="crispEdges"
      {...props}
    >
      <path
        fill="#6F8B6E"
        d="M10 0h1v1h-1zM11 0h1v1h-1zM9 1h1v1H9zM12 1h1v1h-1z"
      />
      <path fill="#B089AB" d="M13 1h1v1h-1z" />
      <path fill="#6F8B6E" d="M9 2h1v1H9z" />
      <path fill="#B089AB" d="M12 2h1v1h-1z" />
      <path fill="#8E6D89" d="M13 2h1v1h-1z" />
      <path fill="#B089AB" d="M14 2h1v1h-1z" />
      <path fill="#6F8B6E" d="M5 3h1v1H5zM6 3h1v1H6zM9 3h1v1H9z" />
      <path fill="#B089AB" d="M13 3h1v1h-1zM4 4h1v1H4z" />
      <path fill="#6F8B6E" d="M7 4h1v1H7zM9 4h1v1H9z" />
      <path fill="#B089AB" d="M3 5h1v1H3z" />
      <path fill="#8E6D89" d="M4 5h1v1H4z" />
      <path fill="#B089AB" d="M5 5h1v1H5z" />
      <path fill="#6F8B6E" d="M7 5h1v1H7zM9 5h1v1H9z" />
      <path fill="#B089AB" d="M4 6h1v1H4z" />
      <path
        fill="#6F8B6E"
        d="M7 6h1v1H7zM9 6h1v1H9zM7 7h1v1H7zM9 7h1v1H9zM10 8h1v1h-1zM11 8h1v1h-1zM9 9h1v1H9zM12 9h1v1h-1z"
      />
      <path fill="#839CA9" d="M13 9h1v1h-1z" />
      <path fill="#6F8B6E" d="M9 10h1v1H9z" />
      <path fill="#839CA9" d="M12 10h1v1h-1z" />
      <path fill="#6D838E" d="M13 10h1v1h-1z" />
      <path fill="#839CA9" d="M14 10h1v1h-1z" />
      <path fill="#6F8B6E" d="M5 11h1v1H5zM6 11h1v1H6zM9 11h1v1H9z" />
      <path fill="#839CA9" d="M13 11h1v1h-1zM4 12h1v1H4z" />
      <path fill="#6F8B6E" d="M7 12h1v1H7zM9 12h1v1H9z" />
      <path fill="#839CA9" d="M3 13h1v1H3z" />
      <path fill="#6D838E" d="M4 13h1v1H4z" />
      <path fill="#839CA9" d="M5 13h1v1H5z" />
      <path fill="#6F8B6E" d="M7 13h1v1H7zM9 13h1v1H9z" />
      <path fill="#839CA9" d="M4 14h1v1H4z" />
      <path fill="#6F8B6E" d="M7 14h1v1H7zM9 14h1v1H9zM7 15h1v1H7zM9 15h1v1H9z" />
    </svg>
  )
}

export const FlowerYellow1 = (props) => {
  return (
    <svg
      aria-hidden="true"
      data-prefix="fas"
      data-icon="flower"
      className="prefix__svg-inline--fa prefix__fa-flower prefix__fa-w-20"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 8 8"
      shapeRendering="crispEdges"
      {...props}
    >
      <path fill="#978C63" d="M4 0h1v1H4zM5 0h1v1H5z" />
      <path fill="#C87E7E" d="M2 1h1v1H2z" />
      <path fill="#978C63" d="M3 1h1v1H3zM6 1h1v1H6z" />
      <path fill="#C87E7E" d="M1 2h1v1H1z" />
      <path fill="#A05E5E" d="M2 2h1v1H2z" />
      <path fill="#C87E7E" d="M3 2h1v1H3z" />
      <path fill="#978C63" d="M6 2h1v1H6zM9 2h1v1H9zM10 2h1v1h-1z" />
      <path fill="#C87E7E" d="M2 3h1v1H2z" />
      <path fill="#978C63" d="M6 3h1v1H6zM8 3h1v1H8z" />
      <path fill="#C87E7E" d="M11 3h1v1h-1z" />
      <path fill="#978C63" d="M6 4h1v1H6zM8 4h1v1H8z" />
      <path fill="#C87E7E" d="M10 4h1v1h-1z" />
      <path fill="#A05E5E" d="M11 4h1v1h-1z" />
      <path fill="#C87E7E" d="M12 4h1v1h-1z" />
      <path fill="#978C63" d="M6 5h1v1H6zM8 5h1v1H8z" />
      <path fill="#C87E7E" d="M11 5h1v1h-1z" />
      <path
        fill="#978C63"
        d="M6 6h1v1H6zM8 6h1v1H8zM6 7h1v1H6zM8 7h1v1H8zM4 8h1v1H4zM5 8h1v1H5z"
      />
      <path fill="#CC9970" d="M2 9h1v1H2z" />
      <path fill="#978C63" d="M3 9h1v1H3zM6 9h1v1H6z" />
      <path fill="#CC9970" d="M1 10h1v1H1z" />
      <path fill="#A97E5C" d="M2 10h1v1H2z" />
      <path fill="#CC9970" d="M3 10h1v1H3z" />
      <path fill="#978C63" d="M6 10h1v1H6zM9 10h1v1H9zM10 10h1v1h-1z" />
      <path fill="#CC9970" d="M2 11h1v1H2z" />
      <path fill="#978C63" d="M6 11h1v1H6zM8 11h1v1H8z" />
      <path fill="#CC9970" d="M11 11h1v1h-1z" />
      <path fill="#978C63" d="M6 12h1v1H6zM8 12h1v1H8z" />
      <path fill="#CC9970" d="M10 12h1v1h-1z" />
      <path fill="#A97E5C" d="M11 12h1v1h-1z" />
      <path fill="#CC9970" d="M12 12h1v1h-1z" />
      <path fill="#978C63" d="M6 13h1v1H6zM8 13h1v1H8z" />
      <path fill="#CC9970" d="M11 13h1v1h-1z" />
      <path fill="#978C63" d="M6 14h1v1H6zM8 14h1v1H8zM6 15h1v1H6zM8 15h1v1H8z" />
    </svg>
  )
}

export const FlowerYellow2 = (props) => {
  return (
    <svg
      aria-hidden="true"
      data-prefix="fas"
      data-icon="flower"
      className="prefix__svg-inline--fa prefix__fa-flower prefix__fa-w-20"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 8 8"
      shapeRendering="crispEdges"
      {...props}
    >
      <path
        fill="#978C63"
        d="M11 1h1v1h-1zM12 1h1v1h-1zM4 2h1v1H4zM5 2h1v1H5zM10 2h1v1h-1zM13 2h1v1h-1z"
      />
      <path fill="#C87E7E" d="M14 2h1v1h-1zM3 3h1v1H3z" />
      <path fill="#978C63" d="M6 3h1v1H6zM10 3h1v1h-1z" />
      <path fill="#C87E7E" d="M13 3h1v1h-1z" />
      <path fill="#A05E5E" d="M14 3h1v1h-1z" />
      <path fill="#C87E7E" d="M15 3h1v1h-1zM2 4h1v1H2z" />
      <path fill="#A05E5E" d="M3 4h1v1H3z" />
      <path fill="#C87E7E" d="M4 4h1v1H4z" />
      <path fill="#978C63" d="M6 4h1v1H6zM10 4h1v1h-1z" />
      <path fill="#C87E7E" d="M14 4h1v1h-1zM3 5h1v1H3z" />
      <path
        fill="#978C63"
        d="M6 5h1v1H6zM10 5h1v1h-1zM6 6h1v1H6zM10 6h1v1h-1zM6 7h1v1H6zM10 7h1v1h-1zM11 9h1v1h-1zM12 9h1v1h-1zM4 10h1v1H4zM5 10h1v1H5zM10 10h1v1h-1zM13 10h1v1h-1z"
      />
      <path fill="#CC9970" d="M14 10h1v1h-1zM3 11h1v1H3z" />
      <path fill="#978C63" d="M6 11h1v1H6zM10 11h1v1h-1z" />
      <path fill="#CC9970" d="M13 11h1v1h-1z" />
      <path fill="#A97E5C" d="M14 11h1v1h-1z" />
      <path fill="#CC9970" d="M15 11h1v1h-1zM2 12h1v1H2z" />
      <path fill="#A97E5C" d="M3 12h1v1H3z" />
      <path fill="#CC9970" d="M4 12h1v1H4z" />
      <path fill="#978C63" d="M6 12h1v1H6zM10 12h1v1h-1z" />
      <path fill="#CC9970" d="M14 12h1v1h-1zM3 13h1v1H3z" />
      <path
        fill="#978C63"
        d="M6 13h1v1H6zM10 13h1v1h-1zM6 14h1v1H6zM10 14h1v1h-1zM6 15h1v1H6zM10 15h1v1h-1z"
      />
    </svg>
  )
}

export const Heart1 = (props) => {
  return (
    <svg
      aria-hidden="true"
      data-prefix="fas"
      data-icon="heart"
      className="prefix__svg-inline--fa prefix__fa-heart prefix__fa-w-20"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 8 8"
      shapeRendering="crispEdges"
      {...props}
    >
      <path
        fill="#E77373"
        d="M1 1h1v1H1zM2 1h1v1H2zM4 1h1v1H4zM5 1h1v1H5zM0 2h1v1H0z"
      />
      <path fill="#EEE1C4" d="M1 2h1v1H1zM2 2h1v1H2z" />
      <path fill="#E77373" d="M3 2h1v1H3z" />
      <path fill="#EEE1C4" d="M4 2h1v1H4zM5 2h1v1H5z" />
      <path fill="#E77373" d="M6 2h1v1H6zM0 3h1v1H0z" />
      <path
        fill="#EEE1C4"
        d="M1 3h1v1H1zM2 3h1v1H2zM3 3h1v1H3zM4 3h1v1H4zM5 3h1v1H5z"
      />
      <path fill="#E77373" d="M6 3h1v1H6z" />
      <path fill="#AA9F83" d="M0 4h1v1H0z" />
      <path fill="#E77373" d="M1 4h1v1H1z" />
      <path fill="#EEE1C4" d="M2 4h1v1H2zM3 4h1v1H3zM4 4h1v1H4z" />
      <path fill="#E77373" d="M5 4h1v1H5z" />
      <path fill="#AA9F83" d="M6 4h1v1H6zM1 5h1v1H1z" />
      <path fill="#E77373" d="M2 5h1v1H2z" />
      <path fill="#EEE1C4" d="M3 5h1v1H3z" />
      <path fill="#E77373" d="M4 5h1v1H4z" />
      <path fill="#AA9F83" d="M5 5h1v1H5zM2 6h1v1H2z" />
      <path fill="#E77373" d="M3 6h1v1H3z" />
      <path fill="#AA9F83" d="M4 6h1v1H4zM3 7h1v1H3z" />
    </svg>
  )
}

export const Heart2 = (props) => {
  return (
    <svg
      aria-hidden="true"
      data-prefix="fas"
      data-icon="heart"
      className="prefix__svg-inline--fa prefix__fa-heart prefix__fa-w-20"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 8 8"
      shapeRendering="crispEdges"
      {...props}
    >
      <path
        fill="#E77373"
        d="M1 1h1v1H1zM2 1h1v1H2zM4 1h1v1H4zM5 1h1v1H5zM0 2h1v1H0z"
      />
      <path fill="#EEE1C4" d="M1 2h1v1H1zM2 2h1v1H2z" />
      <path fill="#E77373" d="M3 2h1v1H3z" />
      <path fill="#EEE1C4" d="M4 2h1v1H4zM5 2h1v1H5z" />
      <path fill="#E77373" d="M6 2h1v1H6zM0 3h1v1H0z" />
      <path
        fill="#EEE1C4"
        d="M1 3h1v1H1zM2 3h1v1H2zM3 3h1v1H3zM4 3h1v1H4zM5 3h1v1H5z"
      />
      <path fill="#E77373" d="M6 3h1v1H6z" />
      <path fill="#C3B797" d="M0 4h1v1H0z" />
      <path fill="#E77373" d="M1 4h1v1H1z" />
      <path fill="#EEE1C4" d="M2 4h1v1H2zM3 4h1v1H3zM4 4h1v1H4z" />
      <path fill="#E77373" d="M5 4h1v1H5z" />
      <path fill="#C3B797" d="M6 4h1v1H6zM1 5h1v1H1z" />
      <path fill="#E77373" d="M2 5h1v1H2z" />
      <path fill="#EEE1C4" d="M3 5h1v1H3z" />
      <path fill="#E77373" d="M4 5h1v1H4z" />
      <path fill="#C3B797" d="M5 5h1v1H5zM2 6h1v1H2z" />
      <path fill="#E77373" d="M3 6h1v1H3z" />
      <path fill="#C3B797" d="M4 6h1v1H4zM3 7h1v1H3z" />
    </svg>
  )
}




